(function() {
  'use strict';

  angular
    .module('up-web-app', ['ui.router', 'ngAnimate', 'ngResource', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'cfp.loadingBar', 'panzoom', 'panzoomwidget', 'jlareau.bowser', 'cb.x2js', 'monospaced.mousewheel', 'ui.slider', 'LocalStorageModule', 'perfect_scrollbar', 'angulartics', 'angulartics.google.analytics']);

})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .factory('SessionFactory', SessionFactory);

  /** @ngInject */
  function SessionFactory($log, localStorageService) {
    var self = this;

    /**
    * File factory
    * @param {string} sessionContainer - Session key
    */
    function SessionFactoryClass(sessionContainer) {
      var self = {};

      /**
      * Get session item
      * @return {string} User id
      */
      self.get = function() {
        return localStorageService.get(sessionContainer) || null;
      };

      /**
      * Add session item
      * @param {string} userId - A user id
      * @return {boolean}
      */
      self.add = function(userId) {
        return localStorageService.set(sessionContainer, userId);
      };

      /**
      * Remove session item
      * @return {boolean}
      */
      self.remove = function() {
        return localStorageService.remove(sessionContainer);
      };

      return self;
    }

    return SessionFactoryClass;
  }


})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .service('PanzoomSessionService', PanzoomSessionService);

  /** @ngInject */
  function PanzoomSessionService($log, SessionFactory) {
    var sessionContainer = 'panzoom';

    /**
     * Panzoom session factory
     */
    function PanzoomSessionFactoryClass() {
      var self = this;

      return self;
    }

    return angular.extend(SessionFactory(sessionContainer), new PanzoomSessionFactoryClass);
  }
})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .service('FilterSessionService', FilterSessionService);

  /** @ngInject */
  function FilterSessionService($log, SessionFactory) {
    var sessionContainer = 'filter';

    /**
     * Filter session factory
     */
    function FilterSessionFactoryClass() {
      var self = this;

      /**
       * Get filter current state
       * @param {string} projectId - A filter project id
       * @return {Object} A filter state information
       */
      self.getState = function(projectId) {
        var session = new SessionFactory(sessionContainer + '-' + projectId);
        return session.get();
      };

      /**
       * Save filter current state
       * @param {string} projectId - A filter project id
       * @param {Object} data - A filter state information
       * @param {string} data.filterAvailabilityMode - Availability mode
       * @param {Object[]} data.filterRooms - An array of room ids
       * @param {Object[]} data.price - An array with keys [min,max]
       * @return {boolean}
       */
      self.saveState = function(projectId, data) {
        var session = new SessionFactory(sessionContainer + '-' + projectId);
        return session.add(data);
      };

      /**
       * Remove filter state
       * @param {string} projectId - A filter project id
       * @return {boolean}
       */
      self.removeState = function(projectId) {
        var session = new SessionFactory(sessionContainer + '-' + projectId);
        return session.remove();
      };

      return self;
    }

    return angular.extend(SessionFactory(sessionContainer), new FilterSessionFactoryClass);
  }
})();

(function() {
  'use strict';

  /**
  * Panzoom marker component
  * @param {number} aoItemX - The starting x position for the element in percentage
  * @param {number} aoItemY - The starting y position for the element in percentage
  * @param {string} [aoTooltip] - A tooltip to be displayed on mouse over
  */
  angular
    .module('up-web-app')
    .component('aoPanzoomMarker', {
      controller: aoPanzoomMarkerController,
      transclude: true,
      require: {
        aoPanzoomCtrl: '^aoPanzoom'
      },
      bindings: {
        aoItemX: '<',
        aoItemY: '<',
        aoTooltip: '@'
      }
    });

  /** @ngInject */
  function aoPanzoomMarkerController($log, $timeout, $element, $q, AoPanzoomService) {
    var ctrl = this;

    /**
     * Component hook - $onInit
     */
    ctrl.$onInit = function() {
      // Actions on resize
      _watchResize();

      // Disable events
      $element.on('mousedown touchstart', function(e) {
        e.stopImmediatePropagation();
      });
    };

    /**
     * Component hook - $postLink
     */
    ctrl.$postLink = function() {
      $timeout(function() {
        // Position must be set depending on window size
        _setElementPos();

        // Tooltip events
        if(ctrl.aoTooltip) {
          // Set tooltip
          _setTooltip();

          // Add hover events for tooltip display
          $element.on('mouseenter', _mouseEnter);
          $element.on('mouseleave', _mouseLeave);
        }
      });

    };

    /**
     * Component hook - $onDestroy
     */
    ctrl.$onDestroy = function() {
      _clearEvents();
      if(ctrl.tooltip) {
        ctrl.tooltip.remove();
      }
    };

    //
    // Public functions
    //

    //
    // Private functions
    //

    /**
     * Set element pos
    */
    function _setElementPos() {
      var container = $element.parents('.panzoom').get(0).getBoundingClientRect();

      // Get parent component image native dimensions
      _getImageDimensions()
        .then(function(panDimensions) {
          // Set marker position depending on those dimensions
          var posX = _setPosX(container, panDimensions);
          var posY = _setPosY(container, panDimensions);

          $log.debug('PANZOOMMARKER - New positions !', posX, posY);

          // Force some styles on element
          $element.css({
            top: posY + 'px',
            left: posX + 'px',
            position: 'absolute',
            cursor: 'pointer'
          });
        });
    }


    /**
    * Set posX
    * @param {Object} container - Container dimensions data
    * @param {Object} panDimensions - pan native dimensions (width and height)
    * @return {number} px
    */
    function _setPosX(container, panDimensions) {
      var ratio = _getRatio(panDimensions.naturalWidth, container.width); // Ratio between container and window

      if(ratio < 1) {
        return _centerElement(Math.round(ctrl.aoItemX * ratio));
      } else {
        return _centerElement(ctrl.aoItemX);
      }
    }

    /**
    * Set posY
    * @param {Object} container - Container dimensions data
    * @param {Object} panDimensions - pan native dimensions (width and height)*
    * @return {number} px
    */
    function _setPosY(container, panDimensions) {
      var ratio = _getRatio(panDimensions.naturalHeight, container.height); // Ratio between container and window

      if(ratio < 1) {
        return _centerElement(Math.round(ctrl.aoItemY * ratio));
      } else {
        return _centerElement(ctrl.aoItemY);
      }
    }

    /**
     * Corrects the given position considering the marker dimensions
     */
    function _centerElement(pos) {
      return pos - $element.width() / 2;
    }

    /**
    * get ratio between values
    * @param {number} val1 - original value
    * @param {number} val2 - actual value
    * @return {number}
    */
    function _getRatio(val1, val2) {
      return val2 / val1;
    }

    /**
    * Mouseenter action
    * @param {Event} event - event
    */
    function _mouseEnter(event) {
      event.preventDefault();
      $log.debug('mouseenter, prepare stuff !');

      // Set tooltip position
      _showTooltip();
    }

    /**
    * Mouseleave action
    * @param {Event} event - event
    */
    function _mouseLeave(event) {
      event.preventDefault();
      $log.debug('mouseleave, remove tooltip !');

      // Remove tooltip
      _showTooltip(false);
    }

    /**
    * Clear events
    */
    function _clearEvents() {
      $element.off('mouseenter');
      $element.off('mouseleave');

      // Unsubscribe onresize
      AoPanzoomService.destroyResize();
    }

    /**
    * Set tooltip
    */
    function _setTooltip() {
      ctrl.tooltip = angular.element('<div class="panzoom-tooltip-box"><div class="arrow"></div><span>'+ ctrl.aoTooltip +'</span></div>');

      // Basic css
      ctrl.tooltip.css({
        position: 'absolute',
        visibility: 'hidden'
      });

      // Add to dom
      $element.after(ctrl.tooltip);

      // Set position
      _setTooltipPosition();
    }

    /**
    * Set tooltip position and show
    */
    function _setTooltipPosition() {
      var boundaries = $element.get(0).getBoundingClientRect();
      var tooltipBoundaries = ctrl.tooltip.get(0).getBoundingClientRect();
      var x = parseInt($element.css('left')) + (boundaries.width / 2) - (tooltipBoundaries.width / 2); // Centered
      var y = parseInt($element.css('top')) + boundaries.height;

      ctrl.tooltip.css({
        width: tooltipBoundaries.width + 'px',
        height: tooltipBoundaries.height + 'px',
        left: x + 'px',
        top: y + 'px'
      });

      // Also fix children dimensions

      angular.forEach(ctrl.tooltip.children(), function(child) {
        var childBoundaries = child.getBoundingClientRect();
        angular.element(child).css({
          height: childBoundaries.height + 'px'
        });
      });
    }

    /**
    * Hide tooltip
    * @param {boolean} status - Show if true
    */
    function _showTooltip(status) {
      var visibility = (status === false) ? 'hidden' : 'visible';

      ctrl.tooltip.css({
        visibility: visibility
      });
    }

    /**
     * Actions on window resizing
     */
    function _watchResize() {
      // On resize event
      AoPanzoomService.watchResize(function() {
        if(ctrl.resizing) return; // do not resize on all iterations

        ctrl.resizing = true; // Resizing, lock process

        $timeout(function() {
          _setElementPos();
          ctrl.resizing = false;
        }, 100);
      });
    }

    /**
     * Get parent component image dimensions safely
     */
    function _getImageDimensions() {
      var defer = $q.defer();
      var img = ctrl.aoPanzoomCtrl.img;
      if(!img) {
        // If no image available, wait a bit and try again
        $log.debug('PANZOOMMARKER - No image available yet, waiting...');
        return $timeout(_getImageDimensions, 200);
      }

      defer.resolve({naturalWidth: img.naturalWidth, naturalHeight: img.naturalHeight});

      return defer.promise;
    }
  }

})();

(function() {
  'use strict';

  /**
  * Orbital filter results component
  * @param {Object} data - The database to search from
  * @param {Object} filter - The user filter
  * @callback [onClose] - Called on close button click
  */
  angular
    .module('up-web-app')
    .component('aoFilterResults', {
      templateUrl: 'app/components/filter/filter-results/filter-results.html',
      controller: aoFilterResultsController,
      bindings: {
        data: '<',
        onClose: '&',
        resultClick: '&'
      }
    });

  // Directive controller function
  /** @ngInject */
  function aoFilterResultsController($log, TranslationService, FilterService) {
    var ctrl = this;

    /**
     * Component hook - $onInit
     */
    ctrl.$onInit = function() {
      $log.debug('FILTERRESULTS - Init');

      //
      // Init vars

      ctrl.translate = TranslationService.translate; // Allow translation
    };

    /**
     * Component hook - $onInit
     */
    ctrl.$onDestroy = function() {
    };

    /**
     * Result click action
     * @param  {Object} item
     */
    ctrl.onResultClick = function(item) {
      ctrl.resultClick({item: item});
    };

    //
    // Private functions
    //

  }

})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .directive('slotSelect', slotSelect);

  /** @ngInject */
  function slotSelect($timeout, $log) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/slotselect/slotselect.html',
      scope: {
        filter: '=?ssFilter',
        list: '=ssList',
        model: '=ssModel'
      },
      controller: slotSelectController,
      link: slotSelectLink,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    // Directive controller function
    /** @ngInject */
    function slotSelectController($scope, $log, $animate, $q) {

      /**** Variables ****/

      var vm = this;
      vm.currentIndex = 0;
      vm.animatedElement = null; // Loaded in link function
      vm.pendingAnimation = false; // A flag to avoid casting an animation while another is running
      vm.maxIndex = 0; // Define default max list index. Updated on init

      /**** Functions ****/

      // Actions to be done on init
      vm.$onInit = function() {
        var index = vm.findListValueIndex(vm.model);
        vm.setCurrentSlideIndex(index);

        // Define max list index
        vm.maxIndex = vm.list.length - 1;
      };

      vm.setCurrentSlideIndex = function(index) {
        vm.currentIndex = index;
      };
      vm.isCurrentSlideIndex = function(index) {
        return vm.currentIndex === index;
      };

      /**
       * Selects an element
       * @param {object} event - The angular $event object
       * @param {integer} index - The selected element index
       */
      vm.selectElement = function(event, index) {
        // If already pending, do nothing
        if (vm.pendingAnimation) {
          $log.debug('SLOTSELECT - Pending, nothing done');
          return;
        }

        if (!angular.equals(vm.currentIndex, index)) {
          animate(index, index < vm.currentIndex); // Trigger animation
        }
      };

      /**
       * Selects the element before current selected index
       */
      vm.selectPreviousElement = function() {
        // If already pending, do nothing
        if (vm.pendingAnimation) {
          $log.debug('SLOTSELECT - Pending, nothing done');
          return;
        }

        var nextIndex = vm.currentIndex - 1;

        // Do nothing if we have reached last element
        if(nextIndex < 0) {
          return;
        }

        animate(nextIndex, true); // Trigger animation
      };

      /**
       * Selects the element after current selected index
       */
      vm.selectNextElement = function() {
        // If already pending, do nothing
        if (vm.pendingAnimation) {
          $log.debug('SLOTSELECT - Pending, nothing done');
          return;
        }

        var nextIndex = vm.currentIndex + 1;

        // Do nothing if we have reached last element
        if(nextIndex > vm.maxIndex) {
          return;
        }

        animate(nextIndex, false); // Trigger animation
      };

      /**
       * Callback triggered on mouse wheel
       * @param {object} event - The angular $event object
       * @param {object} delta - The mousewheel $delta object
       * @param {integer} deltaX - The mousewheel $deltaX value
       * @param {integer} deltaY - The mousewheel $deltaY value (1 if rollup, -1 if rolldown)
       */
      vm.wheel = function(event, delta, deltaX, deltaY) {
        // If already pending, do nothing
        if (vm.pendingAnimation) {
          $log.debug('SLOTSELECT - Pending, nothing done');
          return;
        }

        var currentSlide = vm.currentIndex;

        // Do nothing if first or last element
        var firstElementSlideCancel = currentSlide === 0 && deltaY > 0;
        var lastElementSlideCancel = currentSlide === (vm.maxIndex) && deltaY < 0;
        if (firstElementSlideCancel || lastElementSlideCancel) {
          return;
        }

        var nextSlide = currentSlide - deltaY;
        animate(nextSlide, deltaY > 0); // Trigger animation
      };


      /**
       * Trigger animation
       * @param {integer} index - The slide index
       * @param {bool} direction - The up/down direction to be applied (0 -> downward)
       */
      function animate(index, direction) {
        setModel(vm.list[index]); // Update model value
        var directionClass = setDirectionClass(index, direction); // Set the animation direction
        vm.setCurrentSlideIndex(index); // Update current slide index
        animateByClass(index, directionClass); // Trigger animation
      }

      /**
       * Trigger animation
       * @param {integer} index - The slide index
       * @param {string} directionClass - The up/down direction class to be applied
       */
      function animateByClass(index, directionClass) {
        var deferred = $q.defer();
        vm.pendingAnimation = true; // Set pending

        // Add the class to our element so as to trigger animation
        $animate.addClass(vm.animatedElement, directionClass)
          .then(function() {
            vm.pendingAnimation = false; // Remove pending

            // Remove class once finished
            $animate.removeClass(vm.animatedElement, directionClass);

            deferred.resolve();
          }).catch(function(err) {
            deferred.reject(err);
          });

        return deferred.promise;
      }

      /**
       * Set proper direction class
       * @param {integer} index - The slide index
       * @param {bool} reverse - The direction that will define the set class
       */
      function setDirectionClass(index, reverse) {
        return (reverse) ? 'up' + index : 'down' + index;
      }

      /**
       * Set model value
       * @param {string} value - Value to be applied to model
       */
      function setModel(value) {
        vm.model = value;
      }

      /**
       * Loop on scope list elements to find value
       * @param {string} value - The value to find
       */
      vm.findListValueIndex = function(value) {
        var currentIndex = 0; // Set default value

        // Loop
        angular.forEach(vm.list, function(listValue, index) {
          if (listValue == value) {
            currentIndex = index;
          }
        });

        return currentIndex;
      };
    }


    // Directive link function
    function slotSelectLink(scope, el, attr, vm) {
      // Save element to be animated in scope
      vm.animatedElement = el.find('ul');

      // Move to proper position
      function moveCursor() {
        var height = parseInt(vm.animatedElement.find('li').css('height'));
        var cssTopValue = '-' + ((vm.currentIndex) * height) + 'px';
        $log.debug('SLOTSELECT - User defined model, setting top value :', cssTopValue);
        vm.animatedElement.css('top', cssTopValue);
      }

      moveCursor();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .animation('.ss-slide', slotSelectSlide);

  // Slide animation
  /** @ngInject */
  function slotSelectSlide($animateCss, $log) {
    return {
      // Animation depends onthe classes added on the element
      addClass: function(element, className, done) {
        var height = element[0].firstElementChild.offsetHeight;
        var direction = (className.indexOf('up')) ? '-' : '';
        var top = parseInt(element.css('top'));
        var toY = parseInt(direction + height);
        $log.debug('Moving to %s with height %s, top %s', toY, height, top);

        // Setup animation
        var animator =  $animateCss(element, {
          from: {
            top: top + 'px'
          },
          to: {
            top: top + toY + 'px'
          },
          duration: 0.07 // seconds
        });

        // Start animation
        animator.start()
          .done(function(){
            // Once ended, trigger done callback
            done();
          });
      },

      removeClass: function(element, className, done) {
        done();
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .service('TranslationService', TranslationService);

  /** @ngInject */
  function TranslationService($http, $timeout, $log, $q) {
    var self = this;
    var configUrl = 'app/config.json';
    self.config = '';
    self.language = 'fr';

    //Load translation file
    self.loadConfig = function() {
      var deferred = $q.defer();

      $http.get(configUrl)
        .success(function(data) {
          //Load all config key
          $log.debug('TRANSLATE - Translation config file loaded !');
          self.config = data;
          deferred.resolve();
          // $rootScope.ready = true;
          // $rootScope.$emit('ready');
        })
        .error(function(data, status, header, config) {
          $log.error('Error on reading config.json');
          deferred.reject(new Error('Error on reading config.json'));
        });

      return deferred.promise;
    };

    /**
     *
     * @param {int} id
     * @param {bool} [silent] - No warning emitted if request id not found
     * @returns {string}
     */
    self.translate = function(id, silent) {
      // If no translation found, wait and try again
      if (!self.isLoaded()) {
        $log.debug('TRANSLATE - No config found, waiting...');

        $timeout(function() {
          $log.debug('TRANSLATE - waited, trying again...');
          self.translate(id);
        });

        return '';
      }

      // If config string not found
      if(!self.config.translations[id]) {
        if(!silent) $log.warn('Wrong config string %s', id);
        return '';
      }

      // If no config string found
      if(!self.config.translations[id][self.language]) {
        if(!silent) $log.warn('No translation [%s] found for: %s', self.language, id);
        return '';
      }

      return self.config.translations[id][self.language];

      // }
      // return message;
    };

    self.isLoaded = function() {
      return !angular.equals('', self.config) &&
        angular.isDefined(self.config.translations);
    };
  }


})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .service('RouteCheckService', RouteCheckService);

  /**
   * @ngInject */
  function RouteCheckService($q, $log, $location, RepositoryService) {
    var self = this;

    /** Public Methods **/

    self.checkUrl = function(routeParams) {
      $log.debug('Activate ApartmentController');

      var routeStatus = true; // True if route is ok

      if(angular.isDefined(routeParams.orbitalId)) {
        if(!self.checkOrbital(routeParams.orbitalId)) {
          routeStatus = false;
        }
      }

      if(angular.isDefined(routeParams.apartmentId)) {
        if(!self.checkApartment(routeParams.apartmentId)) {
          routeStatus = false;
        }
      }

      if(angular.isDefined(routeParams.panoramaId)) {
        if(!self.checkPanorama(routeParams.panoramaId)) {
          routeStatus = false;
        }
      }

      return routeStatus;
    };

    self.checkOrbital = function(orbitalId) {

    };

    self.checkApartment = function(apartmentId) {

    };

    self.checkPanorama = function(panoramaId) {

    };
  }

})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .service('RepositoryService', RepositoryService);

  /**
   * @ngInject */
  function RepositoryService(API_URL, PLAN_DESC_FIELDS, ORBITAL_ELEVATOR_FLOORS, $resource, $q, $log, $filter, x2js, TranslationService) {
    var self = this;
    var priceRange = {
      min: 0,
      max: 0
    }; // Init price range
    var contentFile = $resource(API_URL, {idBuilding: 'id'});
    var planConfig = $resource('assets/repository/:idProject/floorplans/:idFloorplan/config.json', {idProject: 'id', idFloorplan: 'idFloorplan'}, {query: {isArray: false}});
    var skyviewConfig = $resource('assets/repository/:idProject/skyviews/skyviews.json', {idProject: 'id'});

    self.config = [];
    self.priceList = []; // The orbital's apartments complete price list
    self.priceRange = angular.copy(priceRange);
    // self.orbitalCustomJson = {};
    self.orbitalId = 1; // Allows to avoid loading the same jsno if alreay loaded
    self.stateCount = 1;

    /* Public methods */

    /**
     * Get plan config
     * @param  {int} idProject
     * @param  {int} idFlat
     */
    self.getPlanConfig = function(idProject, idFlat) {
      var idFloorplan = self.getApartmentConfigProperty(idFlat, 'id-floorplan');
      $log.debug('Loading plan config for idProject %s idFloorplan', idProject, idFloorplan);
      return planConfig.query({idProject: idProject, idFloorplan: idFloorplan}).$promise;
    };

    /**
     * Get skyview config
     * @param  {int} idProject
     */
    self.getSkyviewConfig = function(idProject) {
      return skyviewConfig.query({idProject: idProject}).$promise;
    };

    /**
     * Get apartments data
     */
    self.getFlats = function(orbitalId) {
      return self.config[orbitalId].flats;
    };

    /**
     * Get apartment data
     * @param {integer} apartmentId - The apartment id
     * @param {bool} clone - Allows to clone apartment object so as to not save the modifications
     */
    self.getApartmentConfig = function(apartmentId, clone) {
      if (!self.orbitalId) {
        $log.warn('Orbital id not loaded in repository service');
        return false;
      }

      // Search apartment
      apartmentId = parseInt(apartmentId); // Ensure that apartmentid is an integer
      var apartments = self.getFlats(self.orbitalId);
      var filtered = $filter('filter')(apartments, {id: apartmentId}, true)[0];

      if (clone) {
        return angular.copy(filtered);
      } else {
        return filtered;
      }
    };

    /**
     * Get apartment data property
     * @param {integer} apartmentId - The aparment id
     * @param {string} property - The property to get
     */
    self.getApartmentConfigProperty = function(apartmentId, property) {
      var apartmentConfig = self.getApartmentConfig(apartmentId);
      if (apartmentConfig[property]) {
        return apartmentConfig[property];
      } else {
        $log.warn('Property %s not found for apartment %s', property, apartmentId);
        return;
      }
    };

    /**
     * Get apartment type
     * @param {integer} apartmentId - The aparment id
     */
    self.getApartmentType = function(apartmentId) {
      return self.getApartmentConfigProperty(apartmentId, 'type');
    };

    /**
     * Get apartment type label
     * @param {integer} apartmentId - The aparment id
     */
    self.getApartmentTypeLabel = function(apartmentId) {
      return self.getApartmentConfigProperty(apartmentId, 'typelabel');
    };

    /**
     * Get apartment price
     * @param {integer} apartmentId - The aparment id
     */
    self.getApartmentPrice = function(apartmentId) {
      return Math.floor(self.getApartmentConfigProperty(apartmentId, 'price'));
    };

    /**
     * Get config data property
     * @param {string} property - The property to get
     */
    self.getConfigProperty = function(property) {
      if (!self.orbitalId) {
        $log.warn('Orbital id not loaded in repository service');
        return false;
      }

      return self.config[self.orbitalId][property];
    };

    /**
     * Get building data property
     * @param {integer} buildingId - The building id
     * @param {string} property - The property to get
     */
    self.getBuildingConfigProperty = function(buildingId, property) {
      var buildingConfig = self.getBuildingConfig(buildingId);
      if (buildingConfig[property]) {
        return buildingConfig[property];
      } else {
        $log.warn('Property %s not found for building %s', property, buildingId);
        return;
      }
    };

    /**
     * Get building data from global config object - only available for root view
     * @param {integer} buildingId - The building id
     */
    self.getBuildingConfig = function(buildingId) {
      if (!self.orbitalId) {
        $log.warn('Orbital id not loaded in repository service');
        return false;
      }

      return self.config[self.orbitalId].buildings[buildingId];
    };

    // Loop on current building json for actions
    self.crawlOrbitalApartmentsData = function() {
      var deferred = $q.defer();

      if (!self.orbitalId) {
        $log.warn('Orbital id not loaded in repository service');
        deferred.reject(new Error('Orbital id not loaded in repository service'));
        return deferred.promise;
      }

      $log.debug('REPOSITORYSERVICE - Crawling');

      try {
        var flats = self.getFlats(self.orbitalId);
        var price;
        angular.forEach(flats, function(flat) {
          // Actions to be done while looping on xml*
          if (self.isAvailable(flat.id) && flat.price) {
            // Round up prices
            price = self.getApartmentPrice(flat.id);

            self.addToPriceList(price); // Setup a list of all available budgets
            self.setPriceRange(price); // Set price range
          }
        });

        deferred.resolve();
      } catch (err) {
        $log.error(err);
        deferred.reject(err);
      }

      return deferred.promise;
    };

    /**
     * Add new budget into budget list
     * @param {integer} price - Value that will be set if inferior to the current one
     */
    self.addToPriceList = function(price) {
      // Add into list
      self.priceList.push(price);

      // Sort list
      self.priceList.sort();

      // Deduplicate list
      self.priceList = deduplicate(self.priceList);

      // $log.debug('REPOSITORYSERVICE -  Added value %s to price list :', price, self.priceList);
    };

    /**
     * Clear price range
     */
    self.clearPriceRange = function() {
      self.priceRange = angular.copy(priceRange);
    };

    /**
     * Set min budget for current building
     * @param {integer} price - Value that will be set if inferior to the current one
     */
    self.setPriceRange = function(price) {
      self.priceRange.min = setBudgetMin(price);
      self.priceRange.max = setBudgetMax(price);
      // $log.debug('REPOSITORYSERVICE -  Price range updated : ', self.priceRange);
    };

    /**
     * Get price list
     */
    self.getPriceList = function() {
      return self.priceList;
    };

    /**
     * Get price range
     */
    self.getPriceRange = function() {
      // $log.debug('REPOSITORYSERVICE -  Getting value for price range', self.priceRange);
      return self.priceRange;
    };

    /**
     * Get min budget for current building
     */
    self.getBudgetMin = function() {
      $log.debug('REPOSITORYSERVICE -  Getting value %s for budget min', self.priceRange.min);
      return self.priceRange.min;
    };

    // Get max budget for current building
    self.getBudgetMax = function(defaultValue) {
      return (self.priceRange.max <= 1) ? defaultValue : self.priceRange.max;
    };

    // Clear user filter values
    self.clearBudget = function() {
      self.priceMin = 0;
      self.priceMax = 0;
    };

    /**
     * Load object2vr XML
     * @param {string} orbitalId - The orbital to load
     * @param {bool} crawl - Crawl the xml to find data (example : min/max price)
     */
    self.load = function(orbitalId, crawl) {
      var deferred = $q.defer();

      $log.debug('REPOSITORYSERVICE -  load for orbital %s ...', orbitalId);
      self.orbitalId = orbitalId; // Save loaded id in service

      if (self.isLoaded(orbitalId)) { // Object already loaded, just resolve
        $log.debug('REPOSITORYSERVICE -  Orbital json déjà chargé !');
        deferred.resolve(self.config[orbitalId]);

      } else { // Object not loaded, start !
        self.loadConfig(orbitalId)
          .then(function(data) {
            // Set floor label
            _setFloorLabel(data.flats);

            // Save data into class property
            deferred.resolve(data);
          });
      }

      return deferred.promise;
    };

    /**
     * Load custom json for orbital
     * @param {string} orbitalId - The config orbital id
     */
    self.loadConfig = function(orbitalId) {
      $log.debug('REPOSITORYSERVICE -  loadConfig..');

      return contentFile.get({idBuilding: orbitalId}).$promise;
    };

    /**
     * Save loaded config for orbital
     * @param {string} orbitalId - The config orbital id
     * @param {object} data - The config json object
     */
    self.setConfig = function(orbitalId, data) {
      $log.debug('REPOSITORYSERVICE -  setConfig..');

      self.config[orbitalId] = data;
    };

    /**
     * Check if repository id matches current loaded id
     * @param {string} orbitalId - The id to check
     */
    self.isLoaded = function(orbitalId) {
      return angular.isDefined(self.config[orbitalId]);
    };

    /**
     * Updates orbital xml with orbital config data
     * @param {string} projectId - The project id
     * @param {integer} orbitalId - The orbital id
     * @param {string} xml - An xml config string
     * @param {Object} filters - An array of filter values
     * @param {string} [filters.filterAvailabilityMode=null] - display apartments based on availability -
     * @param {array} [filters.filterRooms=null] - display apartments based on room number
     * @param {integer} [filters.filterBudgetMin=null] - display apartments based on minimum price
     * @param {integer} [filters.filterBudgetMax=null] - display apartments based on maximum price
     */
    self.applyFilterOrbital = function(projectId, orbitalId, xml, filters) {
      $log.debug('REPOSITORYSERVICE -  Orbital apartments type detected ! Apply filter on this type.');

      var deferred = $q.defer();

      // Default values
      var filterAvailabilityMode = filters.filterAvailabilityMode || null;
      var filterRooms = filters.filterRooms || null;
      var filterBudgetMin = filters.filterBudgetMin || null;
      var filterBudgetMax = filters.filterBudgetMax || null;

      $log.debug('REPOSITORYSERVICE - Apply orbital filter with values', filterAvailabilityMode, filterRooms, filterBudgetMin, filterBudgetMax);

      // Translate xml into json
      self.parseXml(xml)
        .then(function(orbitalObject2Vr) {
          try {

            //Retreive states count
            self.stateCount = orbitalObject2Vr.vrobject.input._states;

            if(orbitalObject2Vr.vrobject.hotspots) {

              // Hotspot label
              orbitalObject2Vr.vrobject.hotspots.label = setHotSpotLabel();

              // Hotspot style
              var polystyleMode = (!filterAvailabilityMode || filterAvailabilityMode === "none") ? '2' : '1';
              orbitalObject2Vr.vrobject.hotspots.polystyle = setHotSpotStyle(polystyleMode);

              // Update hotspots
              var polyHotspot = orbitalObject2Vr.vrobject.hotspots.polyhotspot;
              var polyHotspotArray = (polyHotspot.length) ? polyHotspot : [polyHotspot]; // We must pass an array for updateHotspots
              orbitalObject2Vr.vrobject.hotspots.polyhotspot = updateHotspots(polyHotspotArray, {
                filterAvailabilityMode: filterAvailabilityMode,
                filterRooms: filterRooms,
                filterBudgetMin: filterBudgetMin,
                filterBudgetMax: filterBudgetMax
              });

              self.parseJson(orbitalObject2Vr)
                .then(function(xml) {
                  deferred.resolve(xml);
                }).catch(function(err) {
                  $log.error(err);
                  deferred.reject(err);
                });

            } else {
              // Direct resolve if not hotspot data
              deferred.resolve(xml);
            }

          } catch (err) {
            $log.error(err);
            deferred.reject(err);
          }

        }).catch(function(err) {
          $log.error(err);
          deferred.reject(err);
        });

      return deferred.promise;
    };

    /**
     * Check if aparment is available
     * @param {string} id - An apartment id
     */
    self.isAvailable = function(id) {
      var apartmentConfig = self.getApartmentConfig(id);
      return (apartmentConfig.availability > 0) ? false : true;
    };

    /**
     * Secured xml parsing
     * @param {string} xml - xml string to parse into json
     */
    self.parseXml = function(xml) {
      var deferred = $q.defer();

      try {
        var parsed = x2js.xml_str2json(xml);
        deferred.resolve(parsed);
      } catch (err) {
        $log.error(err);
        deferred.reject(err);
      }

      return deferred.promise;
    };

    /**
     * Secured json parsing
     * @param {object} json - json object to parse into xml
     */
    self.parseJson = function(json) {
      var deferred = $q.defer();

      try {
        var parsed = x2js.json2xml_str(json);
        deferred.resolve(parsed);
      } catch (err) {
        $log.error(err);
        deferred.reject(err);
      }

      return deferred.promise;
    };

    /**
     * Get apartment vtour url
     * @param {string} projectId  - The project id
     * @param {string} apartmentId  - The apartment id
     */
    self.getApartmentTourUrl = function(projectId, tourId) {
      return 'assets/repository/' + projectId + '/tours/' + tourId + '/tour.xml';
    };

    /**
     * Get skyview url
     * @param {string} projectId  - The project id
     * @param {string} apartmentId  - The apartment id
     */
    self.getSkyviewUrl = function(projectId, skyviewId) {
      return 'assets/repository/' + projectId + '/skyviews/' + skyviewId + '/tour.xml';
    };

    /**
     * Get the number of state (usualy corresponding to levels count)
     */
    self.getStateCount = function() {
      return self.stateCount;
    };

    /**
     * Get given flat description
     * @param  {int} apartmentId
     */
    self.getFlatDescription = function(apartmentId) {
      var description = {};
      var descProperties = Object.keys(PLAN_DESC_FIELDS);
      if(!PLAN_DESC_FIELDS || descProperties.length === 0) return description;

      angular.forEach(descProperties, function(property) {
        var currentValue = self.getApartmentConfigProperty(apartmentId, property);
        var singleString = '';

        if(PLAN_DESC_FIELDS[property].single && currentValue == 1) {
          singleString = 'Single';
        }

        var prefix = TranslationService.translate('planDescriptionPrefix'+ singleString +'_' + property, true);
        var suffix = TranslationService.translate('planDescriptionSuffix'+ singleString +'_' + property, true);


        description[property] = prefix + currentValue + suffix;
      });

      return description;
    };

    /**
     * Get floor id from label
     * @param  {string} label
     */
    self.getFloorIdFromLabel = function(label) {
      var floorKey = ORBITAL_ELEVATOR_FLOORS.indexOf(label);
      return (floorKey >= 0) ? floorKey + 1 : ORBITAL_ELEVATOR_FLOORS.length;
    };

    /* Private methods */

    /**
     * Set min budget for current building
     * @param {integer} price - Value that will be set if inferior to the current one
     */
    function setBudgetMin(price) {
      if (price > 0) {
        // Initiate budgetMin with first value found
        if (self.priceRange.min === 0) {
          return price;
        } else {
          // If we found a lower value, replace it
          return (price < self.priceRange.min) ? price : self.priceRange.min;
        }
      } else {
        return self.priceRange.min;
      }
    }

    /**
     * Set max budget for current building
     * @param {integer} price - Value that will be set if superior to the current one
     */
    function setBudgetMax(price) {
      return (price > self.priceRange.max) ? price : self.priceRange.max;
    }

    /**
     * Show hide hotspot
     * @param {object} hotspot - Hotspot to hide/show
     * @param {bool} hide - Hotspot will be hidden if true
     */
    function hideHotspot(hotspot, hide) {
      angular.forEach(hotspot.polygon, function(polygon) {
         //0:show -1:hidden
        if(hide === 1) { // hide
          polygon._state = -1;
        } else { // show
          polygon._state = 0;
        }
      });
    }

    /**
     * Change details for all polygons
     * @param {object} hotspotList - An object listing hotspots
     * @param {object} custom - Object an object containing the values to update : {
     *   filterAvailabilityMode: filterAvailabilityMode,
     *   filterRooms: filterRooms,
     *   filterBudgetMin: filterBudgetMin,
     *   filterBudgetMax: filterBudgetMax
     * }
     */
    function updateHotspots(hotspotList, custom) {
      $log.debug('REPOSITORYSERVICE -  Updating hotspots with data : ', custom);

      angular.forEach(hotspotList, function(polyhotspot) {
        //Inspection de l'appartement
        var apartmentId = polyhotspot._id;
        var availability = self.isAvailable(apartmentId);

        // Hide hotspot and go to next apartment if not available
        if (!availability) {
          hideHotspot(polyhotspot, 1);
          return;
        }

        var budget = self.getApartmentPrice(apartmentId);
        var rooms = parseInt(self.getApartmentConfigProperty(apartmentId, 'rooms'));
        var type = self.getApartmentType(apartmentId);

        // Manage hotspot display
        var displayStatus = 0; //0:show 1:hidden

        // Price not matching : hide
        if (custom.filterBudgetMin && (budget < custom.filterBudgetMin || budget > custom.filterBudgetMax)) {
          displayStatus = 1;
        }

        // Availability not matching : hide
        if (custom.filterAvailabilityMode && (custom.filterAvailabilityMode === 'sold' && availability === true ||
            custom.filterAvailabilityMode === 'available' && availability === false)) {
          displayStatus = 1;
        }

        // Type not matching  : hide
        if (custom.filterRooms.length > 0 && custom.filterRooms.indexOf(type) < 0) {
          displayStatus = 1;
        }

        // Missing data : hide
        if (rooms === 0 || budget === 0) {
          displayStatus = 1; //hide this apart
        }

        var ref = self.getApartmentConfigProperty(apartmentId, 'reference');
        var typeLabel = self.getApartmentTypeLabel(apartmentId);
        var surface = parseInt(self.getApartmentConfigProperty(apartmentId, 'surface'), 0);

        //Replace fake values by context values
        polyhotspot._target = '_self';
        polyhotspot._url = "javascript:goToFlat(" + polyhotspot._id + ")";

        // Budget not displayed if 0 or 1
        var budgetElement = "<div class=\"budget\">"+budget+"&nbsp;€</div>";
        if(budget <= 1) {
          budgetElement = "<div class=\"budget\"></div>";
        }

        polyhotspot._title = "<div class=\"polyhotspot-tooltip\"><div class=\"polyhotspot-tooltip-data\"><div class=\"title\"></div><div class=\"type\">"+ref+"</div>"+ budgetElement +"</div><div class=\"action\">Visiter</div><div class=\"polyhotspot-arrow\"></div></div>";

        // Show/hide hotspot
        hideHotspot(polyhotspot, displayStatus);
      });

      return hotspotList;
    }

    // Set hotspot label parameters
    function setHotSpotLabel() {
      return {
        _width: null,
        _backgroundalpha: '1',
        _enabled: '1',
        _height: null,
        _backgroundcolor: '0xffffff',
        _bordercolor: '0x000000',
        _border: '0',
        _textcolor: '0x000000',
        _background: '1',
        _borderalpha: '1',
        _borderradius: '10',
        _wordwrap: '1',
        _textalpha: '1'
      };
    }

    /**
     * Set hotspot style parameters
     * @param {integer} mode - The display mode. Values : 0=off 1=on 2=roll-indi 3=roll-all
     */
    function setHotSpotStyle(mode) {
      return {
        _mode: mode,
        _backgroundalpha: "0.17",
        _backgroundcolor: "0x0000ff",
        _bordercolor: "0x0000ff",
        _borderalpha: "0"
      };
    }

    /**
     * Remove duplicates from an array
     * @param {array} data - The array to be deduplicated
     */
    function deduplicate(data) {
      return data.filter(function(el, i, arr) {
        return arr.indexOf(el) === i;
      });
    }

    /**
     * Set floor label
     * @param  {object} data
     */
    function _setFloorLabel(data) {
      angular.forEach(data, function(item) {
        var floorId = item.floor - 1;
        var floorLabel = ORBITAL_ELEVATOR_FLOORS[floorId];
        item.floor = floorLabel;
      });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .service('Ob2vrService', Ob2vrService);

  /** @ngInject */
  function Ob2vrService(REPOSITORYPATH, $timeout, $log, $http, $q, $location, IsMobileService, RepositoryService, TranslationService, cfpLoadingBar) {
    var self = this;
    var xmlFile = 'orbital-object2vr.xml';
    var xmlFileMobile = 'mobile-orbital-object2vr.xml';

    // Service default values
    self.config = []; // The orbital xml configuration file array

    // View history
    self.savedZoom = null;
    self.savedPan = null;
    self.savedState = null;

    /**
     * Load object2vr player into designated element
     * @param {string} xml -  An xml config string
     * @param {string} elementId - The object2vr container id
     * @param {string} orbitalId - The orbital data repository name
     */
    self.loadPlayer = function(xml, elementId, orbitalId) {
      var deferred = $q.defer();

      try {
        $timeout(function(){
          // Load orbital plugin and parameters
          self.instance = new object2vrPlayer(elementId); // eslint-disable-line no-undef
          self.instance.setBasePath(REPOSITORYPATH + orbitalId + '/');
          self.instance.readConfigString(xml);

          // Save elementId
          self.instance.elementId = elementId;
          self.instance.orbitalId = orbitalId;

          // Restore last view
          self.restoreView();

          deferred.resolve(self.instance);
        });
      } catch (err) {
        $log.error(err);
        deferred.reject(err);
      }

      return deferred.promise;
    };

    /**
     * Update player
     * @param {string} xml - An xml config string
     */
    self.updatePlayer = function(xml) {
      self.loadPlayer(xml, self.instance.elementId, self.instance.orbitalId);
    };

    /**
     * Saves data as object config xml
     * @param {string} orbitalId - The config orbital id
     * @param {string|object} data - The data to include
     */
    self.setConfig = function(orbitalId, data) {
      var deferred = $q.defer();
      try {
        if (angular.equals('string', typeof data)) {
          self.config[orbitalId] = data;
          deferred.resolve();
        } else {
          RepositoryService.parseJson(data)
            .then(function(xml) {
              self.config[orbitalId] = xml;
              deferred.resolve();
            }).catch(function(err) {
              $log.error(err);
              deferred.reject(err);
            });
        }

      } catch (err) {
        $log.error(err);
        deferred.reject(err);
      }
      return deferred.promise;
    };

    /**
     * Check if xml config has been loaded
     * @param {string} orbitalId - The config orbital id
     */
    self.isLoaded = function(orbitalId) {
      return angular.isDefined(self.config[orbitalId]);
    };

    /**
     * Load object2vr XML
     * @param {string} orbitalId - The config orbital id
     */
    self.loadConfig = function(orbitalId) {
      $log.debug('OB2VRSERVICE - Loading xml config...');
      var deferred = $q.defer();

      var desktopUrl = REPOSITORYPATH + orbitalId + '/' + xmlFile;
      var mobileUrl = REPOSITORYPATH + orbitalId + '/' + xmlFileMobile;
      var url = (IsMobileService.check() ? mobileUrl : desktopUrl);

      //Load orbital-object2vr.xml
      $http.get(url)
        .success(function(xml) {
          //Load all config key
          $log.debug('OB2VRSERVICE - %s loaded !', xmlFile);

          // Save data
          self.setConfig(orbitalId, xml);

          deferred.resolve(xml);
        })
        .error(function(data, status, header, config) {
          // alert('Error on reading orbital-object2vr.xml');
          $log.error('Error on reading orbital-object2vr.xml');
          deferred.reject(new Error('Error on reading orbital-object2vr.xml'));
        });

      return deferred.promise;
    };

    /**
     * Restore viewpoint from saved values
     */
    self.restoreView = function() {
      $log.debug("Attempt to restore orbital view");
      if (self.savedZoom && self.savedPan) {
        $log.debug('OB2VRSERVICE - Restoring current view with values : Zoom: %s, Pan : %s', self.savedZoom, self.savedPan);
        self.instance.setFov(self.savedZoom);
        self.instance.setPan(self.savedPan);
        self.instance.changeViewState(self.savedState);
      }
    };

    /**
     * Save viewpoint values into class
     */
    self.saveView = function() {
      $log.debug("Save actual obital view");
      self.savedZoom = self.instance.getFov();
      self.savedPan = self.instance.getPan();
      self.savedState = self.instance.getState();
    };

    /**
     * Reset viewpoint values
     */
    self.resetView = function() {
      self.savedZoom = null;
      self.savedPan = null;
    };

    /**
     * Change the state of Object2VR
     */
    self.setState = function(state) {
      self.savedState = state;
      self.instance.changeViewState(state); //Warning, async function !


    };

    self.nextState = function() {
      var actualState = self.getState();
      var statesCount = RepositoryService.getStateCount();
      if(actualState < statesCount-1) {
        self.setState(actualState+1);
      } else {
        self.setState(0);
      }
    };

    self.previousState = function() {
      var actualState = self.getState();
      var statesCount = RepositoryService.getStateCount();
      if(actualState > 0) {
        self.setState(actualState-1);
      } else {
       self.setState(statesCount-1);
     }
    };

    /**
     * Get the state of Object2VR
     */
    self.getState = function() {
      if(self.savedState !== null) {
        return self.savedState;
      } else if (self.instance) {
        return self.instance.getState();
      } else  {
        return null;
      }
    };

    /**
     * Get actual pan
     */
    self.getPan = function() {
      if(self.instance) {
        return parseInt(self.instance.getPan());
      } else {
        return null;
      }
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .service('IsMobileService', IsMobileService);

  /** @ngInject */
  function IsMobileService($window, $log) {
    var self = this;

    self.check = function() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true;})(navigator.userAgent||navigator.vendor||$window.opera);
        return check;
    };
  }


})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .service('GalleryService', GalleryService)
    .provider('galleryConfig', function() {
      var self = this;

      /**
       * Set gallery path
       * @param {string} path - The path to the gallery directories
       */
      self.setPath = function(path) {
        self.path = path.replace(/\/$/, "") + '/';
      };

      /**
      * Required by Provider interface
      */
      self.$get = function() {
        return this;
      };

    });

  /** @ngInject */
  function GalleryService($log, $q, $resource, galleryConfig) {
    //
    // Init global vars
    //

    var self = this;
    var config = $resource(galleryConfig.path + ':idGallery/config.json', {idGallery: 'id'});

    //
    // Public functions
    //

    /**
     * Get gallery items
     * @param {string} id - The gallery id
     * @return {Object[]} An array of gallery items
     */
    self.getGalleryItems = function(id) {
      var deferred = $q.defer();

      _loadConfig(id)
        .then(function(items) {
          var galleryItems = _setGalleryItems(id, items);
          deferred.resolve(galleryItems);
        }).catch(function(err) {
          deferred.resolve([]);
        });

      return deferred.promise;
    };

    //
    // Private functions
    //

    /**
     * Load custom json for gallery
     * @param {string} id - The gallery id
     */
    function _loadConfig(id) {
      return config.query({idGallery: id}).$promise;
    }

    /**
    * Set gallery item
    * @param {string} id - The gallery id
    * @param {Object[]} items - An array of gallery item
    * @return {Object}
    */
    function _setGalleryItems(id, items) {
      // Loop on items to modify properties
      angular.forEach(items, function(item) {
        item.src = _setPath(id, item.src);
      });

      return items;
    }

    /**
    * Set gallery item path
    * @param {string} id - The gallery id
    * @param {string} src - An item src property
    * @return {string}
    */
    function _setPath(id, src) {
      return galleryConfig.path + id + '/' + src;
    }
  }


})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .service('AoPanzoomService', PanzoomService);

  /** @ngInject */
  function PanzoomService($log, $q, $window, PanZoomService) {
    //
    // Init global vars
    //

    var self = this;
    var INITIALZOOM = 1;

    // Panzoom config
    self.pzConfig = {
      invertMouseWheel: true,
      useHardwareAcceleration: true,
      // chromeUseTransform: true,
      // panOnClickDrag: true,
      zoomLevels: 4,
      scalePerZoomLevel: 1.5,
      keepInBounds: true,
      neutralZoomLevel: 1,
      initialZoomLevel: INITIALZOOM,
      zoomStepDuration: 0.2,
      keepInBoundsDragPullback: true
    }; // use defaults

    //
    // Public functions
    //

    /**
    * Zoom in
    */
    self.zoomIn = function() {
      $log.debug('zoomIn..');
      PanZoomService.getAPI('panzoom1').then(function(api) {
        // you can now invoke the api
        $log.debug(api.model.zoomLevel);
        api.changeZoomLevel(api.model.zoomLevel * self.pzConfig.scalePerZoomLevel);
      });
    };

    /**
    * Zoom out
    */
    self.zoomOut = function() {
      $log.debug('zoomOut..');
      PanZoomService.getAPI('panzoom1').then(function(api) {
        // you can now invoke the api
        $log.debug(api.model.zoomLevel);
        api.changeZoomLevel(api.model.zoomLevel / self.pzConfig.scalePerZoomLevel);
      });
    };

    /**
    * Zoom reset
    */
    self.resetZoom = function() {
      PanZoomService.getAPI('panzoom1').then(function(api) {
        // you can now invoke the api
        api.changeZoomLevel(INITIALZOOM);
        $log.debug('PANZOOM - Zoom reset');
      });
    };

    /**
     * Actions on window resizing
     * @param  {function} action - Action to be done on resize
     */
    self.watchResize = function(action) {
      var oldResize = $window.onresize;

      // On resize event
      $window.onresize = function() {
        // Do not override previously set functions
        if (angular.isFunction(oldResize)) {
          oldResize();
        }
        action();
      };
    };

    /**
     * Destroy resize event
     */
    self.destroyResize = function() {
      $window.onresize = null;
    };

    //
    // Private functions
    //


  }


})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    // .directive('aoPanzoom', aoPanzoom);
    .component('aoPanzoom', {
      templateUrl: 'app/components/panzoom/panzoom.html',
      controller: aoPanzoomController,
      transclude: true,
      bindings: {
        ngSrc: '@'
      }
    });

  /** @ngInject */
  function aoPanzoomController($log, $element, $q, $timeout, AoPanzoomService) {
    var ctrl = this;

    /**
     * Component hook - $onInit
     */
    ctrl.$onInit = function() {
      ctrl.imageLoaded = false;
      ctrl.panzoomModel = {}; // always pass empty object
      ctrl.config = AoPanzoomService.pzConfig;

      // Actions on resize
      _watchResize();
    };

    /**
     * Component hook - $postLink
     */
    ctrl.$postLink = function() {
      // Load image
      _loadImage(ctrl.ngSrc)
        .then(function(img) {
          ctrl.img = img;

          // Get image size for current display
          ctrl.panDimensions = ctrl.getImageDimensions(img);

          // Set image as loaded
          ctrl.imageLoaded = true;
          $log.debug('PANZOOM - Image Loaded !', img);

        }).catch(function(err) {
          $log.debug('PANZOOM - error', err);
        });
    };

    /**
     * Component hook - $destroy
     */
    ctrl.$destroy = function() {
      // Unsubscribe onresize
      AoPanzoomService.destroyResize();
    };

    //
    // Public functions
    //

    /**
    * Get image dimensions depending on current screen
    * @param {Object} img - The image to resize
    * @return {Object} - Image width and height
    */
    ctrl.getImageDimensions = function(img) {
      var boundaries = $element.get(0).getBoundingClientRect();
      var dimensions;
      var ratio = img.naturalWidth / boundaries.width; // Get ratio from component width

      // Restrict dimensions on with or height depending on screen format
      if(boundaries.width > boundaries.height) {
        dimensions = {
          width: boundaries.height,
          height: boundaries.height
        };
      } else {
        dimensions = {
          width: boundaries.width,
          height: img.naturalHeight / ratio
        };
      }

      return dimensions;
    };

    //
    // Private functions
    //

    /**
     * Load panzoom image
     * @param {string} src - Image src
     * @return {Object} Image object
     */
    function _loadImage(src) {
      var deferred = $q.defer();

      try {
        var img = new Image(); // Crée un nouvel élément img
        img.addEventListener('load', function() {
          deferred.resolve(img);
        }, false);
        img.src = src; // définit le chemin de la source
      } catch(err) {
        deferred.reject(err);
      }

      return deferred.promise;
    }

    /**
     * Actions on window resizing
     */
    function _watchResize() {
      AoPanzoomService.watchResize(function() {
        if(!ctrl.img) return;
        if(ctrl.resizing) return; // do not resize on all iterations

        ctrl.resizing = true; // Resizing, lock process

        $timeout(function() {
          // Get image size for current display
          ctrl.panDimensions = ctrl.getImageDimensions(ctrl.img);
          AoPanzoomService.resetZoom();
          ctrl.resizing = false; // Free process
          $log.debug('PANZOOM - Resize, new dimensions !', ctrl.panDimensions);
        }, 100);
      });
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('up-web-app')
        .directive('slOverlay', slOverlay);

    /** @ngInject */
    function slOverlay() {
        var directive = {
            restrict: 'E',
            transclude: true,
            templateUrl: 'app/components/overlay/overlay.html',
            scope: {
              display: '='
            },
            controller: slOverlayController,
            link: slOverlayLink,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        // Directive controller function
        /** @ngInject */
        function slOverlayController($scope, $log, $cookies) {
            var vm = this;

            /**** Functions ****/

            function display(force) {
              vm.display = true;
            }

            // Close overlay
            vm.close = function() {
                $log.debug('Closing overlay', vm.template);
                vm.display = false;
            };

            /*** Events ****/

        }


        // Directive link function
        function slOverlayLink(scope, el, attr, vm) {

        }
    }

})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .component('slOrbitalElement', {
      templateUrl: 'app/components/orbital-element/orbital-element.html',
      controller: slOrbitalElementController,
      bindings: {
        projectId: '<',
        orbitalId: '<',
        panId: '<',
        data: '<',
        ob2vrService: '<'
      }
    })
    .provider('orbitalElementConfig', function() {
      var self = this;

      /**
       * Set custom hotspot
       * @param {Object} hotspot - An object defining a hotspot
       * @param {string} hotspot.src - Hotspot image
       * @param {integer} [hotspot.width] - Width
       * @param {integer} [hotspot.height] - Height
       */
      self.setCustomHotspot = function(hotspot) {
        self.customHotspot = hotspot;
      };

      /**
      * Required by Provider interface
      */
      self.$get = function() {
        return this;
      };

    });

  /** @ngInject */
  function slOrbitalElementController($log, $state, $q, $timeout, $scope, $element, $window, cfpLoadingBar, orbitalElementConfig) {
    var ctrl = this;

    /**
     * Component hook - $onInit
     */
    ctrl.$onInit = function() {
      ctrl.orbitalContainerId = 'orbital-container';
    };

    /**
     * Component hook - $onChanges
     */
    ctrl.$onChanges = function(changesObj) {
      if(changesObj.data && !changesObj.data.isFirstChange()) {
        ctrl.loadPlayer(changesObj.data.currentValue);
      }
    };

    /**
     * Component hook - $postLink
     */
    ctrl.$postLink = function() {
      if(!ctrl.data) return;

      ctrl.loadPlayer(ctrl.data)
        .then(function() {
          applyHotspotSkin();
        });
    };

    /**
     *
     */
    ctrl.$onDestroy = function() {
      cfpLoadingBar.complete();
      $window.stop();
      ctrl.object2vr.updateObject();
    };

    //
    // Public functions
    //

    /**
    * Load ob2vr player
    * @param {string} xml - An object2vr xml string
    * @return {Object} Promise
    */
    ctrl.loadPlayer = function(xml) {
      var deferred = $q.defer();

      if(!xml) {
        deferred.reject(new Error('Missing xml data'));
        return deferred.promise;
      }

      // Load player
      ctrl.ob2vrService.loadPlayer(xml, ctrl.orbitalContainerId, ctrl.orbitalId)
        .then(function(object2vr) {

          // Use pan id if view can't be restored by service
          if(!ctrl.ob2vrService.restoreView(object2vr, ctrl.projectId) && ctrl.panId) {
            $log.debug('ORBITALEL - Set pan to '+ ctrl.panId);
            object2vr.setPan(ctrl.panId);
          }

          // Check progress
          checkLoadingProgress(object2vr);

          // Send object to the view
          ctrl.object2vr = object2vr;

          deferred.resolve();
        }).catch(function(err) {
          $log.error(err);
        });

      return deferred.promise;
    };

    //
    // Private functions
    //

    //$apply periodic for object2vr loading. Stop when loaded.
    function checkLoadingProgress(object2vr) {
      cfpLoadingBar.start();

      $timeout(function() {
        $scope.$apply();

        if (!object2vr || object2vr.isLoaded !== true) {
          checkLoadingProgress(object2vr);
          if(object2vr) {
            var percentLoaded = object2vr.getPercentLoaded();
            cfpLoadingBar.set(percentLoaded);
            ctrl.percentLoadedDisplay = Math.round(percentLoaded * 100);

            // Different display for loader depending on percentage
            if(percentLoaded < 25/100) {
              ctrl.loaderClass = 'waiting';

            } else {
              ctrl.loaderClass = 'info';
            }
          }
        } else {
          $log.debug('ORBITALEL - Chargement terminé');
          ctrl.loaderClass = null; // Reset loader class
          ctrl.percentloadedDisplay = null;
          cfpLoadingBar.complete();
          object2vr.updateObject();
        }
      }, 200);
    }

    /**
    * Apply hotspot skin
    */
    function applyHotspotSkin() {
      var hotspots = $element.find('img');
      var customHotspotParams = orbitalElementConfig.customHotspot;

      if(customHotspotParams && customHotspotParams.src) {
        angular.forEach(hotspots, function(hotspot) {
          hotspot.src = customHotspotParams.src;

          if(customHotspotParams.height)
            hotspot.height = customHotspotParams.height;

          if(customHotspotParams.width)
            hotspot.width = customHotspotParams.width;
        });
      }
    }

  }

})();

(function () {
    'use strict';

    angular
        .module('up-web-app')
        .directive('slNavbar', slNavbar);

    /** @ngInject */
    function slNavbar() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/navbar/navbar.html',
            scope: {
            },
            controller: NavbarController,
            controllerAs: 'vm',
            bindToController: true,
            transclude: true
        };

        return directive;

        /** @ngInject */
        function NavbarController($scope, $rootScope, $log) {
            var vm = this;

        }


    }

})();

(function () {
    'use strict';

    angular
        .module('up-web-app')
        .directive('slHelper', slHelper);

    /** @ngInject */
    function slHelper() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/helper/helper.html',
            scope: {
                template: '=?'
            },
            controller: slHelperController,
            link: slHelperLink,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        // Directive controller function
        /** @ngInject */
        function slHelperController($scope, $log, $cookies, Ob2vrService) {
            var vm = this;

            /**** Functions ****/

            function display(force) {
                // If we click on the button
                if(force) {
                    vm.display = true;
                    return;
                }

                // Check in cookies if helper already displayed
                vm.display = false;
                if(vm.template === 'home') {
                    if(!$cookies.get('home_helper')) {
                        vm.display = true;
                        lockObj2VR(true);
                    }
                } else {
                    if(!$cookies.get('orbital_helper')) {
                        vm.display = true;
                        lockObj2VR(true);
                    }
                }
            }

            // Enable / Disable ob2vr
            function lockObj2VR(status) {
                // Ob2vrService.show(false);
              /*  if(status) {
                    angular.element('#orbital-container').hide();
                } else {
                    angular.element('#orbital-container').show();
                }*/
            }

            function setCookie() {
                $log.debug('Setting cookies for template', vm.template);
                $cookies.put(vm.template + '_helper', true);
            }

            // Close helper
            vm.close = function() {
                $log.debug('Closing helper', vm.template);
                vm.display = false;
                setCookie();
                lockObj2VR(false);
            };

            // Show helper
            vm.show = function() {
                display(true);
            };

            // Display actions
            display();

            /*** Events ****/

        }


        // Directive link function
        function slHelperLink(scope, el, attr, vm) {

        }
    }

})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .filter('thousands', ThousandsFilter);

  /** @ngInject */
  function ThousandsFilter($filter) {
    return function(input, separator) {
      if(!separator) {
        separator = ' ';
      }

      if(input > 999) {
        var number = $filter('number')(input);
        return number.replace(/,/g, separator);
      }else{
        return input;
      }
    };
  }


})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .service('FilterService', FilterService)
    .provider('filterConfig', function() {
      var self = this;

      /**
       * Set params
       * @param {Object} params - The params
       * @param {string} params.priceIncrement - The price increment on filter change
       */
      self.setParams = function(params) {
        self.params = params;
      };

      /**
       * Required by Provider interface
       */
      self.$get = function() {
        return this;
      };

    });

  /** @ngInject */
  function FilterService($log, $http, $q, $resource, Ob2vrService, RepositoryService, FilterSessionService, filterConfig, API_TYPES_URL) {
    var self = this;
    var PRICEINCREMENT = filterConfig.params.priceIncrement; // Prices list incrementation
    var defaultUserData = {
      price: [0, 0], // Save user prices
      filterRooms: [], // User seleted number of rooms
      filterAvailabilityMode: '' // User selected mode
    };
    var typesConfig = $resource(API_TYPES_URL, null, {query: {isArray: true}});

    // self.filterBudgetMin = 0;
    // self.filterBudgetMax = 0;
    self.userData = angular.copy(defaultUserData);
    self.currentOrbitalId = 0;

    /**
     * Load config for type criteria
     */
    self.loadTypeConfig = function() {
      return typesConfig.query().$promise;
    };

    /**
     * Get user data
     * @param {string} projectId - A filter project id
     */
    self.getUserData = function(projectId) {
      return FilterSessionService.getState(projectId);
    };

    /**
     * Set user data
     * @param {string} projectId - A filter project id
     * @param {Object} data - An filter state information
     */
    self.setUserData = function(projectId, data) {
      // Save into session
      FilterSessionService.saveState(projectId, data);

      // Save into service
      self.userData = data;
    };

    /**
     * Get user data
     * @param {string} prop - The user data property
     */
    self.getFilterProperty = function(prop) {
      return self.userData[prop] || null;
    };

    /**
     * Reset service values
     */
    self.clear = function() {
      self.clearUserData();
      // self.clearPriceList();
    };

    /**
     * Clear user data
     * @param {string} projectId - A filter project id
     */
    self.clearUserData = function(projectId) {
      self.userData = angular.copy(defaultUserData);
      FilterSessionService.removeState(projectId);
      $log.debug('FILTERSERVICE - Clearing with data', defaultUserData);
      $log.debug('FILTERSERVICE - New user data', self.userData);
    };

    /**
     * Apply orbital filter from class properties
     * @param {string} projectId - The project id
     * @param {integer} orbitalId - The orbital id
     */
    self.applyFilterOrbital = function(projectId, orbitalId) {
      var deferred = $q.defer();

      RepositoryService.applyFilterOrbital(
        projectId,
        orbitalId,
        Ob2vrService.config[orbitalId], {
          filterAvailabilityMode: self.userData.filterAvailabilityMode,
          filterRooms: self.userData.filterRooms,
          filterBudgetMin: self.userData.price[0],
          filterBudgetMax: self.userData.price[1]
        }).then(function(filteredXml) {
        // Save current viewpoint
        Ob2vrService.saveView();

        // Save new filter
        Ob2vrService.setConfig(orbitalId, filteredXml);

        // Update player
        Ob2vrService.updatePlayer(filteredXml);

        // Restore viewpoint
        Ob2vrService.restoreView();

        deferred.resolve(filteredXml);
      }).catch(function(err) {
        $log.error(err);
        deferred.reject(err);
      });

      return deferred.promise;
    };

    /**
     * Set prices range list
     */
    self.setPricesList = function(budgetMin, budgetMax) {
      $log.debug('FILTERSERVICE - Setting price list');
      var list = [];
      var minPrice = budgetMin - budgetMin % PRICEINCREMENT;
      var maxPrice = budgetMax + budgetMax % PRICEINCREMENT;

      // Build list array
      for (var i = minPrice; i <= maxPrice; i += PRICEINCREMENT) {
        list.push(i);
      }

      return list;
    };

    /**
     * Set user min/max prices
     */
    self.setUserPrices = function(min, max) {
      $log.debug('FILTERSERVICE - Setting user price from', self.userData.price);
      return [
        (self.userData.price[0] === 0) ? min : self.userData.price[0],
        (self.userData.price[1] === 0) ? max : self.userData.price[1]
      ];
    };

    /**
     * Set availability fields
     * @param {string} mode - The filter mode (none, available, sold, all)
     */
    self.setFilterAvailabilityMode = function(mode) {
      if (self.userData.filterAvailabilityMode === mode) { // If already selected, unselect
        $log.debug('FILTERSERVICE - On vide les nb_pieces');
        self.userData.filterAvailabilityMode = '';
        self.userData.filterRooms = []; // Reset selected rooms number
      } else {
        $log.debug('FILTERSERVICE - Passage availability en : ' + mode);
        self.userData.filterAvailabilityMode = mode;

        // If no rooms selected, check them all
        if (self.userData.filterRooms.length === 0) {
          $log.debug('FILTERSERVICE - On remplit toutes les nb-pieces');
          self.userData.filterRooms = [1, 2, 3, 4, 5];
        }
      }
    };

    /**
     * Set the rounded price from initial value
     * @param {integer} price  - The price to roundup
     * @param {string} [method=auto]  - The rounding method (auto, floor or ceil)
     */
    self.setRoundedPrice = function(price, method) {
      var modulo = price % PRICEINCREMENT; // The modulo between our price and the interval
      var rounded;

      if (method === 'floor') {
        rounded = price - modulo;
      } else if (method === 'ceil') {
        rounded = price + (PRICEINCREMENT - modulo);
      } else { // Auto
        // Check if our price is on the lower or upper half of the interval
        var intervalDifference = modulo - (PRICEINCREMENT / 2);
        if (intervalDifference <= 0) { // Lower half, floor price
          rounded = price - modulo;
        } else { // Upper half, ceil price
          rounded = price + (PRICEINCREMENT - modulo);
        }
      }

      return rounded;
    };

    /**
     * Set the rounded price from initial value
     * @param {Object[]} data - The database to search from
     * @param {Object} filter - The user filter
     * @param {Object[]} filter.filterRooms - An array of room type ids
     * @param {Object[]} filter.price - An array with keys [min,max]
     * @return {Object[]} A filtered data object
     */
    self.searchFromData = function(data, filter) {
      if(!filter) {
        return null;
      }

      return data.filter(function(item) {
        var availabilityCheck = true,
          roomsCheck = true,
          priceCheck = true;

        // Availability check
        availabilityCheck = (item.availability === false);

        // Rooms check
        var itemRooms = (item.type) ? item.type : null;
        roomsCheck = (filter.filterRooms && filter.filterRooms.indexOf(itemRooms) >= 0);

        // Price check
        if(filter.price[1] <= 1) { // No price check if no real value
          priceCheck = true;
        } else {
          var itemPrice = (item.price) ? item.price : null;
          priceCheck = (filter.price && itemPrice > filter.price[0] && itemPrice < filter.price[1]);
        }

        return availabilityCheck && roomsCheck && priceCheck;
      });
    };
  }

})();

(function() {
  'use strict';

  /**
   * Orbital filter component
   * @param {Object} data - Preload filter with data
   * @param {number} minPrice - Min price starting value
   * @param {number} maxPrice - Max price starting value
   * @callback [onFilterOpen] - Called on filter opening button click
   * @callback [onFilterSubmit] - Called on filter validation
   */
  angular
    .module('up-web-app')
    .component('aoFilter', {
      templateUrl: 'app/components/filter/filter.html',
      controller: aoFilterController,
      bindings: {
        data: '<',
        minPrice: '<',
        maxPrice: '<',
        typeConfig: '<',
        onFilterOpen: '&',
        onFilterClose: '&',
        onFilterSubmit: '&'
      }
    });

  // Directive controller function
  /** @ngInject */
  function aoFilterController($scope, $log, $timeout, TranslationService, FilterService, filterConfig) {
    var ctrl = this;

    /**
     * Component hook - $onInit
     */
    ctrl.$onInit = function() {
      $log.debug('FILTER - Init');

      //
      // Init vars

      ctrl.translate = TranslationService.translate; // Allow translation
      ctrl.display = false;

      // Fields parameters
      ctrl.fields = {
        rooms: ctrl.typeConfig,
        prices: []
      };

      // Properly round up/down prices
      ctrl.minPrice = FilterService.setRoundedPrice(ctrl.minPrice, 'floor');
      ctrl.maxPrice = FilterService.setRoundedPrice(ctrl.maxPrice, 'ceil');

      // Disable field if price not properly set
      ctrl.priceDisabled = ctrl.maxPrice <= 20000;

      if(!ctrl.priceDisabled) {
        // Set prices fields
        ctrl.data.price = FilterService.setUserPrices(ctrl.minPrice, ctrl.maxPrice);

        // Price step
        ctrl.priceIncrement = filterConfig.params.priceIncrement;
      }
    };

    /**
     * Check if given room is selected
     * @param {integer} roomId - The room id
     */
    ctrl.isFilterRoomSelected = function(roomId) {
      return ctrl.data.filterRooms.indexOf(roomId) >= 0;
    };

    /**
     * Set availability fields
     * @param {string} mode - The filter mode (none, available, sold, all)
     */
    ctrl.selectAvailability = FilterService.setFilterAvailabilityMode;

    /**
     * Switch room filter to given one
     * @param {integer} roomId - The room id
     */
    ctrl.switchFilterRoom = function(roomId) {
      if (ctrl.isFilterRoomSelected(roomId)) {
        // Existe, on le supprime du filtre
        var indexToDelete = ctrl.data.filterRooms.indexOf(roomId);
        ctrl.data.filterRooms.splice(ctrl.data.filterRooms.indexOf(roomId), 1);
      } else {
        // Absent, on l'ajoute au filtre
        ctrl.data.filterRooms.push(roomId);
      }

      // Add availability criteria if at least one room criteria is selected
      if (ctrl.data.filterRooms.length > 0) {
        ctrl.data.filterAvailabilityMode = 'available';
      } else {
        ctrl.data.filterAvailabilityMode = '';
      }
    };

    /**
     * Click ok button
     */
    ctrl.clickOk = function() {
      ctrl.onFilterSubmit({
        data: ctrl.data
      });
      ctrl.close();
    };

    /** Click on close button */
    ctrl.clickClose = function() {
      ctrl.close();
      ctrl.onFilterClose();
    };

    // Close filter
    ctrl.close = function() {
      $log.debug('FILTER - Closing filter', ctrl.template);
      _display(false);
    };

    // Show filter
    ctrl.showFilter = function() {
      _display(true);
      ctrl.onFilterOpen();
    };

    //
    // Private functions
    //

    /**
     * Set display status
     * @param {boolean} status - show if true
     */
    function _display(status) {
      ctrl.display = status;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .directive('slElevator', slElevator);

  /** @ngInject */
  function slElevator() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/elevator/elevator.html',
      scope: {
        projectId: '<',
        buildingId: '<'
      },
      controller: slElevatorController,
      link: slFilterLink,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    // Directive controller function
    /** @ngInject */
    function slElevatorController(ORBITAL_ELEVATOR_FLOORS, $scope, $log, $timeout, $state, TranslationService, Ob2vrService) {
      var vm = this;

      vm.translate = TranslationService.translate; // Allow translation

      // Set floor data
      vm.floors = ORBITAL_ELEVATOR_FLOORS;
      var maxLevel = ORBITAL_ELEVATOR_FLOORS.length - 1;

      /** You can switch state of object2vr with methods of change building with method below **/
      //Change the level
      vm.setState = function(state) {
        //To switch state in object2vr
        Ob2vrService.setState(state);
      };
      //Change the level
      vm.nextState = function() {
        $log.debug('nextState');
        Ob2vrService.nextState();
      };
      //Change the level
      vm.previousState = function() {
        $log.debug('previousState');
        Ob2vrService.previousState();
      };


      //Level :     0 = FULL, 1-6 = RDJ,RDC,1,2,3,4
      //OrbitalId : 1 = FULL, 2-7 = RDJ,RDC,1,2,3,4 (level + 1)
      vm.goPreviousLevel = function() {
        var level = parseInt(vm.buildingId) - 1 ;
        if(level === 0){
          level = maxLevel;
        } else {
          level = level - 1;
        }
        vm.goLevel(level);
      };
      vm.goNextLevel = function() {
        var level = parseInt(vm.buildingId) - 1 ;
        if(level === maxLevel){
          level = 0;
        } else {
          level = level + 1;
        }
        vm.goLevel(level);
      };
      vm.goLevel = function(level) {
        Ob2vrService.saveView();
        var orbitalId = level + 1;
        var pan = Ob2vrService.getPan();
        $state.go('app.orbital', {projectId: vm.projectId, orbitalId: orbitalId, pan: pan} );
      };

      vm.getLevel = function() {
        var level = parseInt(vm.buildingId) - 1;
        return level;
      };


      //Change the level
      vm.getState = function() {
        return Ob2vrService.getState();
      };

    }

    // Directive link function
    function slFilterLink(scope, el, attr, vm) {

    }
  }

})();

(function () {
    'use strict';

    angular
        .module('up-web-app')
        .directive('checkImage', checkImage);

    /** @ngInject */
    function checkImage($http) {
        var directive = {
            restrict: 'A',
            link: function (scope, element, attrs) {
                attrs.$observe('ngSrc', function (ngSrc) {
                    if(angular.isDefined(ngSrc)) {
                        $http.get(ngSrc).success(function () {
                            //Nothing to do
                        }).error(function () {
                            //Png not find, return jpg
                            element.attr('src', ngSrc.replace(/.png$/g, ".jpg")); // set default image
                        });
                    }
                });
            }
        };

        return directive;

    }

})();

(function () {
  'use strict';

  angular
    .module('up-web-app')
    .controller('SkyviewController', SkyviewController);

  /** @ngInject */
  function SkyviewController($log, $rootScope, $stateParams, $state,RepositoryService, skyviewConfig) {
    $log.debug('-- SkyviewController --');

    var vm = this;

    /**
     * Component hook - $onInit
     */
    vm.$onInit = function () {
      vm.isStandalone = angular.isDefined($stateParams.standalone);
      vm.projectId = $stateParams.projectId;
      vm.skyviewId = ($stateParams.skyviewId) ? parseInt($stateParams.skyviewId) : 0;
      vm.showInstructionScreen = false;
      vm.krpano = null;

      // Available skyviews data
      vm.skyviews = skyviewConfig;

      // Prepare next/previous button display
      vm.previous = -1;
      vm.next = -1;
      if(vm.skyviews.length > 0) {
        vm.previous = (vm.skyviews.indexOf(vm.skyviewId-1) >= 0) ? vm.skyviewId-1 : -1;
        vm.next = (vm.skyviews.indexOf(vm.skyviewId+1) >= 0) ? vm.skyviewId+1 : -1;
      }

      // Load krpano
      _loadPano();
    };

    /**
     * Component hook - $onDestroy
     */
    vm.$onDestroy = function () {
      // Remove krpano
      _destroyPano();
    };

    /**
     * Back button action
     */
    vm.goBack = function() {
      $state.go('app.orbital', {projectId: vm.projectId}, {reload: true});
    };

    //
    // Events
    //

    var unsubscribeStateChange = $rootScope.$on('$stateChangeStart',
    function(event, toState, toParams, fromState, fromParams, options){
      _destroyPano();
    });

    //
    // Private functions
    //

    /**
     * Affiche le panorama
     */
    function _loadPano() {
      // $timeout(function () {
        // Setup settings
        var settings = {};

        // Insert krpano into html
        embedpano({
          xml: RepositoryService.getSkyviewUrl(vm.projectId, vm.skyviewId),
          target: "viewerPano",
          id: "viewerPano1",
          html5: "auto",
          mobilescale: 1.0,
          passQueryParameters: true,
          onready: function(krpano) {
            // Save krpano for further usage
            vm.krpano = krpano;
          },
          initvars: settings,
          vars: {
            startscene: 'scene_panorama_' + vm.panoramaId
          },
          consolelog: true
        });


      // }, 100);

    }

    /**
     * Destroy pano
     */
    function _destroyPano() {
      // Remove krpano
      $log.debug('Destruction du viewer 360');
      removepano("viewerPano1");

      // Unsubsribe
      unsubscribeStateChange();
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('up-web-app')
        .controller('PanoramaController', PanoramaController);

    /** @ngInject */
    function PanoramaController($rootScope, $log, $scope, $state, $stateParams, $timeout, RepositoryService, dataConfig, planConfig) {
        $log.debug('-- PanoramaController --');

        var vm = this;

        vm.isStandalone = angular.isDefined($stateParams.standalone);
        vm.planConfig = planConfig;
        vm.projectId = $stateParams.projectId;
        vm.orbitalId = parseInt($stateParams.orbitalId);
        vm.apartmentId = parseInt($stateParams.apartmentId);
        vm.tourId = vm.planConfig.idTour;
        vm.panoramaId = parseInt($stateParams.panoramaId);
        vm.isCardboard = false;
        vm.showInstructionScreen = false;
        vm.krpano = null;



        // Set config
        RepositoryService.setConfig(vm.orbitalId, dataConfig);

        //Affiche le panorama
        vm.display = function () {
            $timeout(function () {
                // Setup settings
                var settings = {};
                settings['isCardboard'] = vm.isCardboard;

                $log.debug('mode cardboard = ' + vm.isCardboard);

                // Insert krpano into html
                embedpano({
                    xml: RepositoryService.getApartmentTourUrl(vm.projectId, vm.tourId),
                    target: "viewerPano",
                    id: "viewerPano1",
                    html5: "auto",
                    mobilescale: 1.0,
                    passQueryParameters: true,
                    onready: activateCardboad,
                    initvars: settings,
                    vars: {
                        startscene: 'scene_panorama_' + vm.panoramaId
                    },
                    consolelog: true
                });


            }, 100);

        };

        function activateCardboad(krpano) {
            // Save krpano for further usage
            vm.krpano = krpano;

            if (vm.isCardboard) {
                $log.debug('is cardboard : activateCardboad..');
                $timeout(function () {
                    $log.debug('Passage automatique en mode cardboard');
                    krpano.call("external_startup();");
                }, 400);
            } else {
                $log.debug('is not cardboard : do nothing..');
            }
        }

        vm.skipInstruction = function () {
            $log.debug("skipInstruction..");
            vm.showInstructionScreen = false;

            // Call krpano internal script
            vm.krpano.call('external_load');
        };

        // Click on start button will trigger this event that allows krpano cb execution
        vm.showInstruction = function () {
            $log.debug("showInstruction..");
            vm.showInstructionScreen = true;
        };


        /********* Initialisations du controlleur **********/

        // all possible event to unregister
        vm.registerEvents = {};


        //Lorsque appli est prête
        function activate() {
            $log.debug('Activate PanoramaController');

            if (angular.isUndefined($stateParams.orbitalId) ||
              isNaN(parseInt($stateParams.orbitalId))) {
              $log.error('Error, no orbitalId');
              vm.errorMessage = $rootScope.translate('orbitalViewErrNoOrbitalId');
            } else {
              if (angular.isUndefined($stateParams.apartmentId) ||
                isNaN(parseInt($stateParams.apartmentId))) {
                $log.error('Error, no apartmentId');
                vm.errorMessage = $rootScope.translate('orbitalViewErrNoOrbitalId');
              } else {

                    if (angular.isUndefined($stateParams.panoramaId) || isNaN(parseInt($stateParams.panoramaId))) {
                        $log.error('Error, no panoramaId');
                        vm.errorMessage = $rootScope.translate('orbitalViewErrNoPanoramaId');
                    } else {
                        //Ok, input info availables, and load showPlan
                        readyAndLoaded();
                    }

                }
            }

        }

        activate();

        //Lorsque appli prête, config et données chargées
        function readyAndLoaded() {
            $log.debug('ReadyAndLoaded PanoramaController');

            vm.display();
        }


        /**
         * Back button action
         */
        vm.goBack = function() {
          $state.go('app.flat', {apartmentId: vm.apartmentId});
        };

        /********* Chargement du controleur **********/

        //On retire les listener de ce controlleur à sa destruction
        $scope.$on('$destroy', function () {
            $log.debug('Desctruction du controlleur');

            // Remove krpano
            $log.debug('Desctruction du viewer 360');
            removepano("viewerPano1");
        });

    }
})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .controller('OrbitalController', OrbitalController);

  /** @ngInject */
  function OrbitalController(SKYVIEW_ACTIVATED, FILTER_ACTIVATED, TRACKING_ACTIVATED, $scope, $state, $stateParams, $log, $q, $analytics, RepositoryService, Ob2vrService, FilterService, object2vrConfigXml, dataConfig, cfpLoadingBar, filterConfig, filterTypeConfig) {
    $log.debug('ORBITALCTRL - -- OrbitalController --');

    /********* Déclarations initiales **********/

    var vm = this;


    /**
     * Component hook - $onInit
     */
    vm.$onInit = function() {
      vm.displayHelper = 'orbital';
      vm.orbitalContainerId = 'orbital-container';
      vm.projectId = $stateParams.projectId; // Set project id
      vm.orbitalId = parseInt($stateParams.orbitalId); // Set orbital id
      vm.panId = $stateParams.pan; // Set pan id
      vm.filterActivated = FILTER_ACTIVATED;
      vm.skyviewActivated = SKYVIEW_ACTIVATED;

      // Load service and data into template
      vm.ob2vrService = Ob2vrService;

      // Filter stuff
      var userFilterData = FilterService.getUserData(vm.projectId); // Get filter user data
      vm.filterData = userFilterData || FilterService.userData;

      // Set config
      vm.dataConfig = dataConfig;
      RepositoryService.setConfig(vm.orbitalId, dataConfig);
      vm.filterTypeConfig = filterTypeConfig;

      // Get filter result list if filter already set
      if(userFilterData) {
        _setFilterResults(userFilterData);
      }

      // Load Object2vr
      _initOrbital();


      /*********** EVENTS ***********/

      // Save point of vue on location change to appartment
      $scope.$on('$stateChangeStart', function(event, toState) {
        if (toState.name === 'app.flat') {
          $log.debug('ORBITALCTRL - Saving current view');
          Ob2vrService.saveView();
        }
      });
    };


    /********* Fonctionnel **********/

    /**
    * Function that will be called from object2vr custom javascript
    * @param {int} flatId - A flat id
    * @param {string} [trackingCategory=Appartement] - A category to be sent to tracker
    */
    vm.goToFlat = function(flatId, trackingCategory) {
      var ref = RepositoryService.getApartmentConfigProperty(flatId, 'reference'); // Get flat reference
      trackingCategory = trackingCategory || 'Appartement'; // Custom tracking category

      _asyncGaTrack(trackingCategory, 'Clic', ref)
        .then(function() {
          // Change state
          $state.go('app.flat', {apartmentId: flatId});
        });
    };

    /**
    * Function that will be called from object2vr custom javascript
    * @param {int} orbitalId - An orbital id
    */
    vm.goToOrbital = function(orbitalId) {
      $state.go('app.orbital', {orbitalId: orbitalId});
    };

    vm.goToSkyview = function() {
      _asyncGaTrack('Skyview', 'Clic')
        .then(function() {
          // Change state
          $state.go('app.skyview');
        });
    };

    /**
     * Function that will be called when click on change level button
     * @param   {string} state level (0 = first level)
     */
    vm.setState = function(state) {
      Ob2vrService.setState(state);
    };

    /**
    * On filter submit action
    * @param {Object} filter - A filter state information
    */
    vm.onFilterSubmit = function(filter) {
      // Type tracking event
      if(filter.filterRooms.length > 0) {
        _trackTypeCriteria(filter.filterRooms);
      }

      // Price tracking event
      _trackPriceCriteria(filter.price);

      // Save filter
      FilterService.setUserData(vm.projectId, filter);

      // Apply
      FilterService.applyFilterOrbital(vm.projectId, vm.orbitalId)
        .then(function() {
          _displayFilterResults(true);
        });

      // Set filter results
      _setFilterResults(filter);
    };

    /**
    * On filter open actions
    */
    vm.onFilterOpen = function() {
      _setFilterResults(null); // Clear filter results
    };

    /**
    * On filter result close button click
    */
    vm.onFilterResultClose = function() {
      FilterService.clearUserData(vm.projectId);

      // Reset filter
      FilterService.applyFilterOrbital(vm.projectId, vm.orbitalId);

      _setFilterResults(null); // Remove filter results
    };

    /**
     * Filter result click action
     * @param  {Object} item
     */
    vm.onResultClick = function(item) {
      vm.goToFlat(item.id, 'Resultat recherche');
    };

    //
    // Private functions
    //

    /**
     * Custom sync ga track to replace synchronous $analytics
     * @param  {string} category
     * @param  {string} action
     * @param  {string} label
     */
    function _asyncGaTrack(category, action, label) {
      var deferred = $q.defer();
      label = label || null;

      try {
        if(TRACKING_ACTIVATED) {
          // Tracking event
          ga('send', {
            hitType: 'event',
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            hitCallback: function() {
              deferred.resolve();
            }
          });
        } else {
          deferred.resolve();
        }
      } catch (error) {
        deferred.reject(error);
      }

      return deferred.promise;
    }

    /**
     * Load view orbital
     */
    function _initOrbital() {
      var deferred = $q.defer();


      // Loop on data to find values for filter
      RepositoryService.crawlOrbitalApartmentsData()
        .then(function() {
          // Set prices values for filter
          vm.minPrice = RepositoryService.getBudgetMin();
          vm.maxPrice = RepositoryService.getBudgetMax(filterConfig.params.priceIncrement);

          // Apply filters
          $log.debug('ORBITALCTRL - Loading orbital filter');

          RepositoryService.applyFilterOrbital(
              vm.projectId,
              vm.orbitalId,
              object2vrConfigXml, {
                filterAvailabilityMode: vm.filterData.filterAvailabilityMode,
                filterRooms: vm.filterData.filterRooms,
                filterBudgetMin: vm.filterData.price[0],
                filterBudgetMax: vm.filterData.price[1]
            }).then(function(filteredXml) {
              // $log.debug('ORBITALCTRL - home xml : ', filteredXml);

              // Scope variables
              vm.ob2vrData = filteredXml; // ob2vr element data
            });

        });

      return deferred.promise;
    }

    /**
    * Show filter results
    * @param {boolean} status - show if true
    */
    function _displayFilterResults(status) {
      vm.displayFilterResults = status;
    }

    /**
    * Set filter results
    * @param {Object} filter - Filter object
    */
    function _setFilterResults(filter) {
      vm.filterResults = FilterService.searchFromData(dataConfig.flats, filter);
    }

    /**
     * Track type criteria
     * @param  {Array} types - An array of the user selected types
     */
    function _trackTypeCriteria(types) {
      if(!types || types.length === 0) return;

      angular.forEach(types, function(type) {
        $analytics.eventTrack('Clic', {  category: 'Recherche Type', label: type });
      });
    }

    /**
     * Track price criteria
     * @param  {array} price - An array defining the user's min/max budget
     */
    function _trackPriceCriteria(price) {
      if(!price || price.length === 0 || price[1] <= 1) return;

      $analytics.eventTrack('Clic', {  category: 'Recherche Prix', label: price[1] });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .controller('ApartmentController', ApartmentController);

  /** @ngInject */
  function ApartmentController(GALLERY_ACTIVATED, PLAN_DESC_ACTIVATED, PLAN_PANORAMA_ACTIVATED, PLAN_STATIC_PATH, $log, $state, $stateParams, TranslationService, RepositoryService, AoPanzoomService, PanzoomSessionService, planConfig, galleryItems, psConfig) {

    $log.debug('-- ApartmentController --');

    var vm = this;

    /**
     * Component hook - $onInit
     */
    vm.$onInit = function() {
      // View variables
      vm.translate = TranslationService.translate; // Allow translation
      vm.projectId = $stateParams.projectId;
      vm.orbitalId = parseInt($stateParams.orbitalId);
      vm.apartmentId = parseInt($stateParams.apartmentId);
      vm.galleryActivated = GALLERY_ACTIVATED;
      vm.panoramaActivated = PLAN_PANORAMA_ACTIVATED;

      // Available description fields
      vm.descActivated = PLAN_DESC_ACTIVATED;
      if(PLAN_DESC_ACTIVATED) {
        vm.desc = RepositoryService.getFlatDescription(vm.apartmentId);
      }

      vm.registerEvents = {};

      // Repository data
      vm.title = RepositoryService.getApartmentConfigProperty(vm.apartmentId, 'title');
      vm.planConfig = planConfig;

      if(planConfig.duplex) {
        var currentFloorId = RepositoryService.getApartmentConfigProperty(vm.apartmentId, 'floor');
        var duplexFloorId = RepositoryService.getApartmentConfigProperty(planConfig.duplex, 'floor');

        vm.isDuplexUpperFloor = (duplexFloorId < currentFloorId) ? true : false;
      }

      // Init ps vars
      vm.psOpen = false;
      vm.psOptions = psConfig.options;
      vm.psTemplate = psConfig.template;
      vm.galleryItems = galleryItems;

      // Init panzoom image
      vm.isPlanDisplayed = PanzoomSessionService.get();
      _initPanzoom();

      // Init markers

    };

    /********* Fonctionnel **********/

    vm.isPlanDisplayedSwitched = function() {
      vm.isPlanDisplayed = !vm.isPlanDisplayed;
      PanzoomSessionService.add(vm.isPlanDisplayed);
      _initPanzoom();
    };

    /**
     * Ps gallery trigger
     * @param {number} index - item index
     */
    vm.startPsGallery = function(index) {
      vm.psOptions.index = index;
      vm.psOpen = true;
    };

    /**
     * Ps close gallery cb
     */
    vm.closePsGallery = function() {
      vm.psOpen = false;
    };

    /**
     * Go to panorama
     */
    vm.startPanorama = function() {
      var startFrom = _getStartFrom();
      $state.go('app.panorama', {panoramaId: startFrom, apartmentId: vm.apartmentId});
    };

    vm.clickMarker = function(panoramaId) {
      var startFrom = _getStartFrom();
      $state.go('app.panorama', {panoramaId: startFrom + panoramaId, apartmentId: vm.apartmentId});
    };

    /**
     * @param  {int} flatId
     */
    vm.goToFlat = function(flatId) {
      $state.go('app.flat', {apartmentId: flatId});
    };

    /**
     * Back button action
     */
    vm.goBack = function() {
      $state.go('app.orbital');
    };

    /**
     * Private functions
     */

    /**
     * Init panzoom image
     */
    function _initPanzoom() {
      var planPath = 'assets/repository/' + vm.projectId + '/';
      var idFloorplan = RepositoryService.getApartmentConfigProperty(vm.apartmentId, 'id-floorplan');


      // Set plan url
      if(vm.isPlanDisplayed && vm.planConfig.idPlan) {
        if(PLAN_STATIC_PATH) {
          planPath += 'static-plans/';
        } else {
          planPath += 'floorplans/';
        }

        vm.planPath = planPath + vm.planConfig.idPlan + '/plan.jpg';
      } else {
        vm.planPath = planPath + 'floorplans/' + idFloorplan + '/plan-cotes.jpg';
      }

      AoPanzoomService.resetZoom();

    }

    /**
     * Get start from or default value
     */
    function _getStartFrom() {
      return planConfig.startFrom || 0;
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .run(runBlock)
    /**
    * Global provider for photoswipe
    */
    .provider('psConfig', function() {
      var self = this;

      /**
       * Set photoswipe params
       * @param {Object} params - An object of photoswipe parameters
       */
      self.setOptions = function(params) {
        self.options = params;
      };

      /**
       * Set photoswipe template
       * @param {string} path - A template path
       */
      self.setTemplate = function(path) {
        self.template = path;
      };

      /**
      * Required by Provider interface
      */
      self.$get = function() {
        return this;
      };

    });


  /** @ngInject */
  function runBlock($rootScope, $log, bowser, TranslationService, IsMobileService) {

    //
    // Global values
    //

    $rootScope.browser = bowser.name.toLowerCase(); // Detect browser
    $rootScope.isMobile = IsMobileService.check(); // Detect device type

    //
    // Global actions
    //

    // Load translation service and set translate method available everywhere
    TranslationService.loadConfig();
    $rootScope.translate = TranslationService.translate;

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .config(routeConfig);

  function routeConfig(ORBITAL_ELEVATOR_FLOORS, $stateProvider, $urlRouterProvider, $locationProvider) {
    $stateProvider
      .state('app', {
        abstract: true,
        url: '/:projectId/building/:orbitalId',
        template: '<section class="app-content" ui-view></section>',
        resolve: {
          dataConfig: function($log, $stateParams, RepositoryService) {
            $log.debug('Loading data config');
            return RepositoryService.load($stateParams.orbitalId);
          }
        },
        controller: 'AppController as vm'
      })
      .state('app.orbital', {
        url: '/orbital?pan',
        templateUrl: 'app/orbital/orbital.html',
        resolve: {
          object2vrConfigXml: function($log, $stateParams, Ob2vrService) {
            $log.debug('Loading ob2vr config');
            return Ob2vrService.loadConfig($stateParams.orbitalId);
          },
          filterTypeConfig: function($log, FilterService, FILTER_ACTIVATED) {
            if(!FILTER_ACTIVATED) {
              $log.debug('Filter is disabled');
              return null;
            }

            $log.debug('Loading filter type config');
            return FilterService.loadTypeConfig();
          }
        },
        controller: 'OrbitalController as vm'
      })
      .state('app.flat', {
        url: '/apartment/:apartmentId',
        templateUrl: 'app/apartment/apartment.html',
        resolve: {
          planConfig: function($log, $stateParams, dataConfig, RepositoryService) {
            $log.debug('Loading plan config');
            RepositoryService.setConfig($stateParams.orbitalId, dataConfig);
            return RepositoryService.getPlanConfig($stateParams.projectId, $stateParams.apartmentId);
          },
          galleryItems: function(GALLERY_ACTIVATED, GALLERY_REPOSITORY_PROPERTY, $log, $stateParams, dataConfig, RepositoryService, GalleryService) {
            if(!GALLERY_ACTIVATED) return false;

            try {
              var flatId = parseInt($stateParams.apartmentId);
              var dirName = RepositoryService.getApartmentConfigProperty(flatId, GALLERY_REPOSITORY_PROPERTY);

              return GalleryService.getGalleryItems(dirName);
            } catch (error) {
              $log.error(error);
              return '';
            }

          }
        },
        controller: 'ApartmentController as vm'
      })
      .state('app.panorama', {
        url: '/apartment/:apartmentId/panorama/:panoramaId?standalone',
        templateUrl: 'app/panorama/panorama.html',
        resolve: {
          planConfig: function($log, $stateParams, dataConfig, RepositoryService) {
            $log.debug('Loading plan config');
            RepositoryService.setConfig($stateParams.orbitalId, dataConfig);
            return RepositoryService.getPlanConfig($stateParams.projectId, $stateParams.apartmentId);
          }
        },
        controller: 'PanoramaController as vm'
      })
      .state('app.skyview', {
        url: '/skyview/:skyviewId?standalone',
        templateUrl: 'app/skyview/skyview.html',
        resolve: {
          skyviewConfig: function($stateParams, $q, RepositoryService) {
            var deferred = $q.defer();

            RepositoryService.getSkyviewConfig($stateParams.projectId)
              .then(function(config) {
                deferred.resolve(config);
              }).catch(function(){
                deferred.resolve([]);
              });

            return deferred.promise;
          }
        },
        controller: 'SkyviewController as vm'
      });

    // Default route redirection
    var defaultId = ORBITAL_ELEVATOR_FLOORS.length;
    $urlRouterProvider.otherwise('/project/building/'+ defaultId +'/orbital');

    $locationProvider.html5Mode(false);
  }

})();

(function () {
    'use strict';

    angular
        .module('up-web-app')
    .constant('REPOSITORYPATH', 'assets/repository/') //Chemin des données
    .constant('API_URL', 'assets/repository/static-api/building.json')
    .constant('API_TYPES_URL', 'assets/repository/static-api/types.json')
    .constant('TRACKING_ACTIVATED', false)
    /** Hide filter if false */
    .constant('FILTER_ACTIVATED', false)
    /** Show skyview button in orbital state if true */
    .constant('SKYVIEW_ACTIVATED', false)
    /** Hide plan description block if false */
    .constant('PLAN_DESC_ACTIVATED', true)
    /** Hide plan panorama button block if false */
    .constant('PLAN_PANORAMA_ACTIVATED', false)
    /** plan.jpg path will be changed into /static-plan/ if true (instead of /floorplans/) */
    .constant('PLAN_STATIC_PATH', false)
    /** Gallery button will be available in plan state if true */
    .constant('GALLERY_ACTIVATED', false)
    /** Defines the property used to store gallery images, usually type or reference */
    .constant('GALLERY_REPOSITORY_PROPERTY', 'reference')
    /** Properties to be displayed in plan state. Define a single property to display a different string if the numeric value is 1 */
    .constant('PLAN_DESC_FIELDS', {'rooms': {single: true}, 'surface': {}})
    /** Orbital floors */
    .constant('ORBITAL_ELEVATOR_FLOORS', []);

})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .config(config);

  /** @ngInject */
  function config(TRACKING_ACTIVATED, $logProvider, $compileProvider, $analyticsProvider, cfpLoadingBarProvider, localStorageServiceProvider, filterConfigProvider, psConfigProvider, galleryConfigProvider) {
    // Enable log
    $logProvider.debugEnabled(false);

    // Loading bar
    cfpLoadingBarProvider.includeSpinner = false;
    cfpLoadingBarProvider.parentSelector = '#loading-bar-container';

    // Whitelisting
    $compileProvider.imgSrcSanitizationWhitelist(/^\s*((https?|ftp|file|blob|chrome-extension):|data:image\/)/);
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|file|chrome-extension):/);

    // Session config
    localStorageServiceProvider.setStorageType('sessionStorage');

    // Orbital filter
    filterConfigProvider.setParams({
      priceIncrement: 10000
    });

    // Photoswipe provider
    psConfigProvider.setOptions({
      history: false,
      fullscreenEl: false,
      shareEl: false,
      counterEl: false,
      arrowEl: true,
      zoomEl: false,
      tapToToggleControls: false,
      closeOnScroll: false
    });
    psConfigProvider.setTemplate('app/ng-photoswipe.html');

    // Gallery params
    galleryConfigProvider.setPath('assets/repository/project/galleries/');

    // Tracking
    $analyticsProvider.developerMode(!TRACKING_ACTIVATED);
  }

})();

(function() {
  'use strict';

  angular
    .module('up-web-app')
    .controller('AppController', AppController);

  /** @ngInject */
  function AppController($scope, $log, $stateParams, RepositoryService, dataConfig) {
    $log.debug('APPCTRL - Start');

    /********* Déclarations initiales **********/

    var vm = this;
    var orbitalId = parseInt($stateParams.orbitalId); // Set orbital id
  }

})();

angular.module("up-web-app").run(["$templateCache", function($templateCache) {$templateCache.put("app/ng-photoswipe.html","<div><div class=pswp tabindex=-1 role=dialog aria-hidden=true><div class=pswp__bg></div><div class=pswp__scroll-wrap><div class=pswp__container><div class=pswp__item></div><div class=pswp__item></div><div class=pswp__item></div></div><div class=\"pswp__ui pswp__ui--hidden\"><div class=pswp__top-bar><div class=pswp__counter></div><button class=\"pswp__button pswp__button--close\" title=\"Close (Esc)\"></button> <button class=\"pswp__button pswp__button--share\" title=Share></button> <button class=\"pswp__button pswp__button--fs\" title=\"Toggle fullscreen\"></button> <button class=\"pswp__button pswp__button--zoom\" title=\"Zoom in/out\"></button><div class=pswp__preloader><div class=pswp__preloader__icn><div class=pswp__preloader__cut><div class=pswp__preloader__donut></div></div></div></div></div><div class=\"pswp__share-modal pswp__share-modal--hidden pswp__single-tap\"><div class=pswp__share-tooltip></div></div><button class=\"pswp__button pswp__button--arrow--left\" title=\"Previous (arrow left)\"></button> <button class=\"pswp__button pswp__button--arrow--right\" title=\"Next (arrow right)\"></button><div class=pswp__caption><div class=pswp__caption__center></div></div></div></div></div></div>");
$templateCache.put("app/apartment/apartment.html","<div class=\"container apartment\"><div class=\"section container-plan\"><!-- Panzoom display - normal mode --><ao-panzoom ng-src={{vm.planPath}} class=sl-panzoom><ao-panzoom-marker ng-click=vm.clickMarker(panoramaId) ng-repeat=\"(panoramaId,panorama) in vm.planConfig.panoramas\" class=panzoom-marker ao-item-x=panorama.x ao-item-y=panorama.y ng-if=vm.isPlanDisplayed analytics-event=Clic analytics-category=\"Visite 360\" analytics-on></ao-panzoom-marker></ao-panzoom></div><div class=switch-zone ng-class=\"{view3d: vm.isPlanDisplayed, quote: !vm.isPlanDisplayed}\" ng-click=vm.isPlanDisplayedSwitched() ng-if=vm.planConfig.idPlan><div class=switch-icon><img src=assets/images/more.svg alt=\"{{vm.translate(\'planViewDesactivateCotations\')}}\" title=\"{{vm.translate(\'planViewDesactivateCotations\')}}\"></div></div><div class=button-module-container><div class=button-duplex ng-class=\"{up: !vm.isDuplexUpperFloor, down: vm.isDuplexUpperFloor}\" ng-click=vm.goToFlat(vm.planConfig.duplex) ng-if=vm.planConfig.duplex><span ng-if=!vm.isDuplexUpperFloor>{{vm.translate(\'planDuplexButtonFloor2\')}}</span> <span ng-if=vm.isDuplexUpperFloor>{{vm.translate(\'planDuplexButtonFloor1\')}}</span></div><div class=button-gallery ng-click=vm.startPsGallery(0) ng-if=\"vm.galleryActivated && vm.galleryItems.length > 0\" analytics-event=Clic analytics-category=Galerie analytics-on><span>{{vm.translate(\'planViewGalleryButton\')}}</span></div><div class=button-panorama ng-click=vm.startPanorama() ng-if=\"vm.panoramaActivated && vm.planConfig.idTour\" analytics-event=Clic analytics-category=\"Visite 360\" analytics-on><span>{{vm.translate(\'planViewPanoramaButton\')}}</span></div></div><!-- Erreur --><div id=orbital-error ng-show=errorMessage>{{errorMessage}}</div><div class=apartment-info ng-if=vm.descActivated><h2>{{vm.translate(\'planDescriptionTitle\')}}<br><span>{{vm.translate(\'planDescriptionSubtitle\')}}{{vm.title}}</span></h2><div class=apartment-info-body ng-if=vm.planConfig.duplex>{{vm.translate(\'planDescriptionDuplex\')}}</div><div class=apartment-info-body ng-repeat=\"property in vm.desc\" ng-if=vm.desc>{{property}}</div></div></div><sl-navbar ng-click=vm.goBack()><img src=assets/images/orbital.svg></sl-navbar><!-- Display gallery --><div ng-photoswipe slides=vm.galleryItems template={{vm.psTemplate}} options=vm.psOptions is-opened=vm.psOpen on-close=vm.closePsGallery() ng-if=\"vm.galleryActivated && vm.psOptions\"></div>");
$templateCache.put("app/orbital/orbital.html","<div class=\"container orbital\"><!--\r\n    For iframe :\r\n    Add scrolling=\"no\"\r\n    Add allowfullscreen=\"yes\"\r\n    --><!-- Contener Object2VR --><div class=section><!--Filter--><ao-filter data=vm.filterData min-price=vm.minPrice max-price=vm.maxPrice type-config=vm.filterTypeConfig on-filter-open=vm.onFilterOpen() on-filter-close=vm.onFilterResultClose() on-filter-submit=vm.onFilterSubmit(data) ng-if=vm.filterActivated></ao-filter><ao-filter-results data=vm.filterResults ng-if=vm.filterResults on-close=vm.onFilterResultClose() ng-if=vm.filterActivated result-click=vm.onResultClick(item)></ao-filter-results><sl-elevator project-id=vm.projectId building-id=vm.orbitalId ng-class=\"{\'cyclo-active\': vm.skyviewActivated}\"></sl-elevator><!-- Logo artefacto --><!-- <div class=\"logo-madeby\"><img src=\"assets/images/artefacto_blanc.png\" /></div> --><!-- Orbital container --><!-- <div id=\"orbital-container\" class=\"orbital-content\" ng-hide=\"vm.errorMessage\"></div> --><sl-orbital-element ob2vr-service=vm.ob2vrService data=vm.ob2vrData project-id=vm.projectId orbital-id=vm.orbitalId pan-id=vm.panId ng-hide=vm.errorMessage ng-if=vm.ob2vrData></sl-orbital-element><!-- Barre de chargement / Voir composant cfpLoadingBar--><!-- <div class=\"orbital-loading\" ng-hide=\"vm.object2vr.isLoaded || vm.menuOpened\">{{translate(\'orbitalViewLoading\')}}\r\n        {{vm.object2vr.getPercentLoaded()*100 | number:0}}{{vm.object2vr.getPercentLoaded()?\'%\':\'\'}}\r\n      </div> --><!-- Link to skyview see constants for disabled it --><div ng-if=vm.skyviewActivated class=link-skyview ng-click=vm.goToSkyview()></div><!-- Disclaimer --><div class=not-contractual-image>{{translate(\'globalContractualVisual\')}}</div></div><sl-navbar ng-hide=\"vm.orbitalId === 0\" ng-click=vm.goToOrbital(0)><img src=assets/images/orbital.svg></sl-navbar></div>");
$templateCache.put("app/panorama/panorama.html","<div class=\"container panorama\"><!-- header --><!-- <div class=\"logo-madeby\" ng-show=\"!vm.showInstructionScreen && !vm.isCardboard\"><img src=\"assets/images/artefacto_blanc.png\" /></div> --><div id=viewerPano class=\"section container-pano\" ng-class=\"{\'no-cardboard\': !vm.isCardboard}\"><noscript><table style=width:100vw;height:100vh><tr style=vertical-align:middle><td><div style=text-align:center>ERROR:<br><br>Javascript not activated<br><br></div></td></tr></table></noscript></div><!-- Erreur --><div id=orbital-error ng-show=vm.errorMessage>{{vm.errorMessage}}</div><div class=cardboard-instructions ng-show=\"!vm.errorMessage && vm.showInstructionScreen\"><div class=\"bloc blocLeft\"><div class=number>1</div><div class=image1></div><div class=text>{{translate(\'cardboardViewStep1\') | uppercase}}</div></div><div class=\"bloc blocRight\"><div class=number>2</div><div class=image2></div><div class=text>{{translate(\'cardboardViewStep2\') | uppercase}}</div></div><div class=clear></div><div class=button ng-click=vm.skipInstruction()>{{translate(\'cardboardViewStartButton\') | uppercase}}</div></div><!-- <div class=\"not-contractual-image\" ng-show=\"!vm.isCardboard && !vm.showInstructionScreen\">{{translate(\'globalContractualVisual\')}}</div> --><sl-navbar ng-click=vm.goBack() ng-if=!vm.isStandalone><img src=assets/images/plan.svg></sl-navbar></div>");
$templateCache.put("app/skyview/skyview.html","<div class=\"container skyview\"><div id=viewerPano class=\"section container-cyclo\" ng-class=\"{\'no-cardboard\': !vm.isCardboard}\"><noscript><table style=width:100vw;height:100vh><tr style=vertical-align:middle><td><div style=text-align:center>ERROR:<br><br>Javascript not activated<br><br></div></td></tr></table></noscript></div><sl-navbar ng-hide=vm.isStandalone ng-click=vm.goBack()><img src=assets/images/orbital.svg></sl-navbar><!-- Specify the skyviews ids on orbital config --><div class=skyviewprevious ui-sref=\"app.skyview({skyviewId: vm.previous})\" ui-sref-opts=\"{reload: true, notify: true}\" ng-if=\"vm.previous >= 0\"></div><div class=skyviewnext ui-sref=\"app.skyview({skyviewId: vm.next})\" ui-sref-opts=\"{reload: true, notify: true}\" ng-if=\"vm.next >= 0\"></div></div>");
$templateCache.put("app/components/elevator/elevator.html","<!-- Bouton elevator --><div class=elevator-container ng-if=\"vm.floors && vm.floors.length > 0\"><ul class=elevator-bar><!-- 1 level = 1 building --><li class=elevator-button ng-click=vm.goPreviousLevel()><img src=assets/images/slider-reverse.png></li><li class=elevator-button ng-repeat=\"(floorId, floor) in vm.floors\" ng-class=\"{active: vm.getLevel()===floorId}\" ng-click=vm.goLevel(floorId)>{{floor}}</li><li class=elevator-button ng-click=vm.goNextLevel()><img src=assets/images/slider.png></li></ul></div>");
$templateCache.put("app/components/filter/filter.html","<!-- Bouton filtre --><div class=filter-container ng-hide=$ctrl.display><div class=\"btn-semi-circle circle-bottom filter-search\" ng-click=$ctrl.showFilter()></div></div><!-- Page de filtre --><div class=slfilter ng-show=$ctrl.display><div class=slfilterlogo></div><div class=slfilteroptions><div class=slblocoption ng-if=$ctrl.fields.rooms><div class=title>{{$ctrl.translate(\'orbitalFilterRoomsTitle\')}}</div><div class=choices ng-class=\"{\'small\': $ctrl.fields.rooms.length < 4}\"><div class=block-select ng-repeat=\"room in $ctrl.fields.rooms\" ng-click=$ctrl.switchFilterRoom(room.id)><div class=checkbox ng-class=\"{\'checked\': $ctrl.isFilterRoomSelected(room.id)}\"></div><div class=select-text>{{room.label}}</div></div></div></div><div class=slblocoption ng-if=!$ctrl.priceDisabled><div class=title>{{$ctrl.translate(\'orbitalFilterBudgetTitle\')}}</div><div class=\"choices form-slider\"><span>{{$ctrl.data.price[0]}}€</span><div ui-slider=\"{range: true}\" min={{$ctrl.minPrice}} max={{$ctrl.maxPrice}} step={{$ctrl.priceIncrement}} use-decimals ng-model=$ctrl.data.price></div><span>{{$ctrl.data.price[1]}}€</span></div></div></div><div class=slfilteractions><div class=btnvalidate ng-click=$ctrl.clickOk()>{{$ctrl.translate(\'orbitalFilterButtonValidate\')}}</div></div></div><div class=\"btn-semi-circle circle-bottom filter-close\" ng-click=$ctrl.clickClose() ng-show=$ctrl.display></div>");
$templateCache.put("app/components/helper/helper.html","<sl-overlay display=vm.display><div class=slhelper-home ng-include=\"\'app/components/helper/home_helper.html\'\" ng-if=\"vm.template == \'home\'\"></div><div class=slhelper-orbital ng-include=\"\'app/components/helper/orbital_helper.html\'\" ng-if=\"vm.template == \'orbital\'\"></div></sl-overlay><div class=slhelper-show-button ng-click=vm.show() ng-if=!vm.display><img src=assets/images/helper-ouvrir.png></div>");
$templateCache.put("app/components/helper/home_helper.html","<div class=slhelper-content><img src=assets/images/helper-immeuble-blanc.png><p>Choisir l\'immeuble</p><button ng-click=vm.close()>Ok, j\'ai compris</button></div>");
$templateCache.put("app/components/helper/orbital_helper.html","<div class=slhelper-content><div class=inline><img src=assets/images/helper-360-blanc.png><p>1. Voir l\'immeuble sous tous ses angles</p></div><div class=inline><img src=assets/images/helper-zoom-blanc.png><p>2. Zoomer pour voir l\'immeuble plus en détail</p></div><div class=inline><img src=assets/images/helper-recherche-blanc.png><p>3. Afficher les appartements correspondant à vos critères</p></div><button ng-click=vm.close()>Ok, j\'ai compris</button></div>");
$templateCache.put("app/components/navbar/navbar.html","<div class=navbar><div class=\"btn-semi-circle circle-top\" ng-transclude></div></div>");
$templateCache.put("app/components/orbital-element/orbital-element.html","<div class=orbital-loading ng-class=[$ctrl.loaderClass] ng-if=$ctrl.loaderClass><p><i class=\"fas fa-spinner fa-spin\"></i> {{$ctrl.percentLoadedDisplay}} %</p><p ng-if=\"$ctrl.loaderClass === \'waiting\'\">Initialisation...</p><p ng-if=\"$ctrl.loaderClass === \'info\'\">Mise en cache...</p></div><div id=orbital-container class=orbital-content></div>");
$templateCache.put("app/components/overlay/overlay.html","<div class=sloverlay ng-show=vm.display><div class=sloverlay-translude ng-transclude></div><div class=sloverlay-close-button ng-click=vm.close() ng-if=vm.display><img src=assets/images/helper-fermer.png></div></div>");
$templateCache.put("app/components/panzoom/panzoom.html","<div class=panzoom-container><panzoom config=$ctrl.config model=$ctrl.panzoomModel class=panzoom id=panzoom1 ng-if=$ctrl.imageLoaded pz-width=$ctrl.panDimensions.width pz-height=$ctrl.panDimensions.height ng-style=$ctrl.panDimensions><!-- Plan --> <img ng-src={{$ctrl.ngSrc}} class=plan ng-style=$ctrl.panDimensions> <svg class=panzoom-overlay ng-style=$ctrl.panDimensions><rect width=100% height=100% rx=10 ry=10 style=fill:none;stroke-width:2;stroke:none /></svg><!-- Pastilles --><div ng-transclude></div></panzoom><div class=spinner ng-if=!$ctrl.imageLoaded><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div></div>");
$templateCache.put("app/components/slotselect/slotselect.html","<div class=slot-select><div class=\"slot-select-controller up\" ng-click=vm.selectPreviousElement() ng-class=\"{\'hidden\': vm.currentIndex === 0}\"></div><div class=slot-select-container><ul class=\"slot-select ss-slide\" msd-wheel=\"vm.wheel($event, $delta, $deltaX, $deltaY)\"><li class=slot-select-element>--</li><li class=slot-select-element ng-repeat=\"(index, label) in vm.list\" ng-click=\"vm.selectElement($event, index)\" ng-class=\"{\'selected\': vm.isCurrentSlideIndex(index)}\"><span ng-if=!vm.filter>{{label}}</span> <span ng-if=vm.filter>{{label | currency:\'\':0}}CHF</span></li></ul></div><div class=\"slot-select-controller down\" ng-click=vm.selectNextElement() ng-class=\"{\'hidden\': vm.currentIndex === vm.maxIndex}\"></div></div>");
$templateCache.put("app/components/filter/filter-results/filter-results.html","<!-- Filter results --><section class=filter-results-container><header><h2>{{$ctrl.data.length}} {{$ctrl.translate(\'filterResultsTitle%\')}}</h2></header><div class=close ng-click=$ctrl.onClose()><i class=\"glyphicon glyphicon-remove\"></i></div><div class=filter-results><perfect-scrollbar class=scroller wheel-propagation=true wheel-speed=1 min-scrollbar-length=200 ng-if=\"$ctrl.data.length > 0\"><ul class=filter-results-list><li ng-repeat=\"item in $ctrl.data\" ng-click=$ctrl.onResultClick(item)><h3>{{$ctrl.translate(\'filterResultsList%Title\')}} {{item.rooms}} <span ng-if=\"item.rooms <= 1\">{{$ctrl.translate(\'filterResultsListTitle%\')}}</span> <span ng-if=\"item.rooms > 1\">{{$ctrl.translate(\'filterResultsListTitle%s\')}}</span></h3><h4>{{item.surface}}m<sup>2</sup> / {{item.floor}}</h4><data class=price value={{item.price}} ng-if=\"item.price > 1\">{{item.price | thousands}} <abbr class=currency title=EUR>€</abbr></data></li></ul></perfect-scrollbar><p ng-if=\"$ctrl.data.length === 0\">{{$ctrl.translate(\'filterResultsEmpty\')}}</p></div></section>");}]);